import React from "react";

const intro_set = [
    {
        id: "0-0-0",
        title: "특별한 만찬",
        dom_animation: "fade_in",
        background: [],
        msg: "지도를 따라 저택 입구에 도착했다.\n" +
            "경호원들이 분주히 다가와\n" +
            "내 얼굴에 가면을 씌웠다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "0-1-0",
                }
            },
        ]
    },
    {
        id: "0-1-0",
        title: "특별한 만찬",
        background: [],
        msg: "\"10번의 대화 후 당신의\n" +
            "가면이 정해집니다.\"\n" +
            "알 수 없는 말을 하고\n" +
            "경호원들이 떠났다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "0-2-0",
                }
            },
        ]
    },
    {
        id: "0-2-0",
        title: "특별한 만찬",
        background: [],
        msg: "거대한 문을 열었다.\n" +
            "이미 파티는 한창이다.\n" +
            "내 이름이 적힌 자리로 갔다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "0-3-0",
                }
            },
        ]
    },
    {
        id: "0-3-0",
        title: "특별한 만찬",
        background: [],
        msg: "이미 네 사람이 테이블에 앉아있다.\n" +
            "에클린 백작부인은 누구지?",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "0-4-0",
                }
            },
        ]
    },
    {
        id: "0-4-0",
        title: "대화 시작",
        dom_animation: "fade_in",
        background: [],
        msg: "일단 가까이 있는 사람들에게\n" +
            "말을 걸어봐야겠다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                    next_id: "0-select",
                }
            },
        ]
    },
    {
        id: "0-select",
        title: "대화상대 고르기",
        dom_animation: "fade_in",
        background: [
            <img className="background_1" key={1} alt="bg"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/select/bg.png"/>
        ],
        msg: "누구에게 말을 걸어 볼까?",
        choice_set: [
            {
                title: "신비로운 분장",
                dom_animation: "fade_in",
                target: {
                    id: 4
                }
            },
            {
                title: "야수 탈",
                dom_animation: "fade_in",
                target: {
                    id: 2
                }
            },
            {
                title: "귀족 마스크",
                dom_animation: "fade_in",
                target: {
                    id: 3
                }
            },
            {
                title: "호러가면",
                dom_animation: "fade_in",
                target: {
                    id: 1
                }
            },
        ]
    }
];

const ending_set = [
    {
        id: "5-0-0",
        title: "에클린 백작 부인",
        dom_animation: "fade_in",
        background: [],
        msg: "대화가 무르익어갈 즈음\n" +
            "백작부인이 등장했다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "5-1-0"
                }
            },
        ]
    },
    {
        id: "5-1-0",
        title: "에클린 백작 부인",
        background: [],
        msg: "반갑습니다. 여러분,\n" +
            "오래 기다리셨어요.\n" +
            "저만 빼고 벌써 다들 친해진 건 아니죠?",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "5-3-0"
                }
            },
        ]
    },
    {
        id: "5-3-0",
        title: "에클린 백작 부인",
        background: [],
        msg: "어머, 당신은...\n" +
            "아주 멋진 가면을 쓰고 있네요.\n" +
            "어디서 오셨죠?",
        choice_set: [
            {
                title: "어, 저는...",
                dom_animation: "fade_in",
                target: {
                    id: "5-4-0"
                }
            },
        ]
    },
    {
        id: "5-4-0",
        title: "에클린 백작 부인",
        background: [],
        msg: "쉿. 다 알고 있어요.\n" +
            "이 공간은 당신의 마음을\n" +
            "가면으로 만들어줘요.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "5-5-0"
                }
            },
        ]
    },
    {
        id: "5-5-0",
        title: "에클린 백작 부인",
        background: [],
        msg: "지금껏 당신은 사실...\n" +
            "아무 가면도 쓰고있지 않았어요.\n" +
            "이제는 아주 예쁜 가면을 쓰고있군요.",
        choice_set: [
            {
                title: "분명 쓴 느낌이..",
                dom_animation: "fade_in",
                target: {
                    id: "5-6-0"
                }
            },
        ]
    },
    {
        id: "5-6-0",
        title: "에클린 백작 부인",
        dom_animation: "fade_in",
        background: [],
        msg: "궁금하죠?\n" +
            "당신의 가면을 보여드릴게요.",
        choice_set: [
            {
                title: "가면보기",
                dom_animation: "fade_in",
                target: {
                    is_result: true,
                }
            },
        ]
    },

    {
        id: "5-bad",
        title: "분노한 백작부인",
        dom_animation: "fade_in",
        background: [],
        msg: "이런,\n" +
            "분노한 에클린 백작부인에게\n" +
            "얼굴을 뺏겼어요\n" +
            "다시 시작해서 얼굴을 되찾아보세요.",
        choice_set: [
            {
                title: "다시하기",
                dom_animation: "fade_in",
                target: {
                    is_reset: true,
                }
            },
        ]
    }
];

const horror_mask_script_set = [
    {
        id: "1-0-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "킥킥, 나한테 말 건거야?\n" +
            "겁도 없는 녀석이구나?",
        choice_set: [
            {
                title: "역할극 중이신거죠?",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "1-0-1"
                },
            },
            {
                title: "겁이 없는건 당신이겠지.",
                dom_animation: "fade_in",
                target: {
                    id: "1-0-2"
                },
            },
            {
                title: "뭐하는 누구세요?",
                dom_animation: "fade_in",
                effect: "eye_light",
                target: {
                    id: "1-0-3"
                }
            }
        ]
    },
    {
        id: "1-0-1",
        title: "호러가면",
        msg: "아, 맞아요. 놀라셨나요?\n" +
            "역할극중에는 역할극에 집중하는게\n" +
            "좋아요.\n" +
            "다시 말걸어주실래요?",
        choice_set: [
            {
                title: "아, 네...",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "1-1-0"
                }
            }
        ],
    },
    {
        id: "1-0-2",
        title: "호러가면",
        msg: "이 몸 앞에서 까부는 걸 보니\n" +
            "배짱이 넘치는 녀석이구나~!\n" +
            "내 심기를 너무 거스르지 않는게\n" +
            "좋을거야",
        choice_set: [
            {
                title: "그러시던가",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-2-0"
                }
            }
        ],
    },
    {
        id: "1-0-3",
        title: "호러가면",
        msg: "음...그냥\n" +
            "죽이는 살인마 정도로 해두지!",
        choice_set: [
            {
                title: "(웃기는 양반이군..)",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-2-0"
                }
            }
        ]
    },

    {
        id: "1-1-0",
        title: "호러가면",
        is_talk: true,
        msg: "내게 말을 건 거야?\n" +
            "키킥, 어리석은 녀석...",
        choice_set: [
            {
                title: "역할극은 어렵네요...",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "1-1-1"
                },
            },
            {
                title: "잘 못 말걸었습니다.",
                dom_animation: "fade_in",
                target: {
                    id: "1-1-2"
                },
            },
            {
                title: "뭐하는 누구세요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-0-3"
                },
            }
        ]
    },
    {
        id: "1-1-1",
        title: "호러가면",
        msg: "안타깝게 됐네요. 조심해요.\n" +
            "에클린 백작부인은 분위기 망치는걸\n" +
            "아주 싫어하니까요.",
        choice_set: [
            {
                title: "그러죠, 뭐",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-2-0"
                }
            }
        ],
    },
    {
        id: "1-1-2",
        title: "호러가면",
        msg: "빨리 도망치는게 좋을거다.\n" +
            "좀 만 더 알짱거렸다간,\n" +
            "가만두지 않을거야. 키킥",
        choice_set: [
            {
                title: "아 예...",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-2-0"
                }
            }
        ],
    },

    {
        id: "1-2-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "그래 어디 발버둥쳐봐라 가여운 것.\n" +
            "궁금한게 뭐냐?",
        choice_set: [
            {
                title: "이 파티는 처음인가요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-2-1",
                }
            },
            {
                title: "내 가면 어때요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-2-2"
                }
            },
            {
                title: "몇 명이나 희생시켰지?",
                dom_animation: "fade_in",
                target: {
                    id: "1-2-3"
                },
            }
        ]
    },
    {
        id: "1-2-1",
        title: "호러가면",
        msg: "매 년 희생양을 찾아서 참가하고 있다.\n" +
            "올 해의 희생양은....\n" +
            "네가될 것 같군",
        choice_set: [
            {
                title: "아, 네..",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },
    {
        id: "1-2-2",
        title: "호러가면",
        msg: "음.. 아직 무르익지 않았어.\n" +
            "좀 더 먹음직스러워질 때까지 두고보마",
        choice_set: [
            {
                title: "뭔 소린지..",
                dom_animation: "fade_in",
                weight: {
                    flex: 1,
                },
                target: {
                    id: "3-9-0",
                }
            }
        ],
    },
    {
        id: "1-2-3",
        title: "호러가면",
        msg: "나? 아니면,\n" +
            "에클린 백작부인을 이야기하는 거냐.",
        choice_set: [
            {
                title: "에클린 백작부인?",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                },
                target: {
                    id: "1-3-0",
                }
            }
        ],
    },

    {
        id: "1-3-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "하 이런...\n" +
            "에클린 백작부인 이야기는..\n" +
            "못들은 걸로 해라",
        choice_set: [
            {
                title: "내가 왜요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-3-1"
                }
            },
            {
                title: "알겠어요",
                dom_animation: "fade_in",
                target: {
                    id: "1-3-2"
                }
            },
            {
                title: "(뭔가 있어 분명...)",
                dom_animation: "fade_in",
                target: {
                    id: "1-3-3"
                }
            },
        ]
    },
    {
        id: "1-3-1",
        title: "호러가면",
        msg: "정말 마음에 안드는 녀석이군.\n" +
            "너랑 말하는건 하나도 재미없다.",
        choice_set: [
            {
                title: "나도 재미없어",
                dom_animation: "fade_in",
                weight: {
                    patience: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },
    {
        id: "1-3-2",
        title: "호러가면",
        msg: "좋아, 다시 해보지!\n" +
            "네 놈이 101번 째 희생양이다!",
        choice_set: [
            {
                title: "뭐 이런...",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },
    {
        id: "1-3-3",
        title: "호러가면",
        msg: "이유는 너무 궁금해하지마라\n" +
            "곧 알게 될거다. 크큭...",
        choice_set: [
            {
                title: "고개를 끄덕인다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },

    {
        id: "1-4-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "끈질기게 말 거는군,\n" +
            "이토록 나를 방해하는 이유가 뭐냐!!",
        choice_set: [
            {
                title: "대화가 하고싶어요",
                dom_animation: "fade_in",
                target: {
                    id: "1-4-1",
                }
            },
            {
                title: "말투가 재밌어서요.",
                dom_animation: "fade_in",
                target: {
                    id: "1-4-2",
                }
            },
            {
                title: "별 이유 없어요.",
                dom_animation: "fade_in",
                target: {
                    id: "1-4-3"
                }
            }
        ]
    },
    {
        id: "1-4-1",
        title: "호러가면",
        msg: "대화따윈 필요없어\n" +
            "얌전히 목이나 씻고,\n" +
            "기다리라고",
        choice_set: [
            {
                title: "그러죠 뭐",
                dom_animation: "fade_in",
                weight: {
                    flex: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-5-0"
                }
            }
        ],
    },
    {
        id: "1-4-2",
        title: "호러가면",
        msg: "크큭..간이 배 밖으로 나왔군...\n" +
            "목숨 아까운 줄 알라고!",
        choice_set: [
            {
                title: "네. 뭐...",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1,
                },
                target: {
                    id: "2-9-0",
                }
            }
        ],
    },
    {
        id: "1-4-3",
        title: "호러가면",
        msg: "싱거운 녀석\n" +
            "귀찮게 하지마라. 또 귀찮게하면\n" +
            "가만두지 않겠어",
        choice_set: [
            {
                title: "알겠어요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-5-0"
                }
            }
        ],
    },

    {
        id: "1-5-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "저 말라비틀어진 점쟁이 분장한 놈.\n" +
            "네놈보다 마음에 안 들어\n" +
            "어떻게 혼내주지...?",
        choice_set: [
            {
                title: "왜요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-5-1"
                }
            },
            {
                title: "어..음...싫어요.",
                dom_animation: "fade_in",
                target: {
                    id: "1-5-2"
                }
            },
            {
                title: "도와줄까요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-5-3"
                }
            }
        ]
    },
    {
        id: "1-5-1",
        title: "호러가면",
        msg: "뭐랄까.. 네 녀석보다 더\n" +
            "귀찮은 냄새가 난다.",
        choice_set: [
            {
                title: "(너가 더...)",
                dom_animation: "fade_in",
                weight: {
                    patience: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-6-0"
                }
            }
        ],
    },
    {
        id: "1-5-2",
        title: "호러가면",
        msg: "우물쭈물대는 모습을 보니\n" +
            "머리 끝까지 화가 나는군,\n" +
            "네 놈도 같이 괴롭혀주마",
        choice_set: [
            {
                title: "그러세요...",
                dom_animation: "fade_in",
                weight: {
                    flex: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "1-6-0"
                }
            }
        ],
    },
    {
        id: "1-5-3",
        title: "호러가면",
        msg: "듣던 중 반가운 소리다!\n" +
            "네 놈이 웬일로 옳은 소리를하는군!!",
        choice_set: [
            {
                title: "갑시다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                },
                target: {
                    id: "4-10-0",
                }
            }
        ],
    },

    {
        id: "1-6-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "어이, 모자란 녀석.\n" +
            "그래 너 말야\n" +
            "너는 어떨 때 가장 즐겁나?",
        choice_set: [
            {
                title: "사색을 즐길 때",
                dom_animation: "fade_in",
                target: {
                    id: "1-6-1"
                }
            },
            {
                title: "유희를 즐길 때",
                dom_animation: "fade_in",
                target: {
                    id: "1-6-2"
                }
            },
            {
                title: "목표를 이룰 때",
                dom_animation: "fade_in",
                effect: "eye_light",
                target: {
                    id: "1-6-3"
                }
            },
            {
                title: "완전한 휴식",
                dom_animation: "fade_in",
                target: {
                    id: "1-6-4"
                }
            },
        ]
    },
    {
        id: "1-6-1",
        title: "호러가면",
        msg: "마음에 안드는군 정말\n" +
            "특별한 대답을 기대한\n" +
            "나의 실수다.",
        choice_set: [
            {
                title: "피차일반입니다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                    flex: 1,
                    forgive: 1,
                    patience: 1,
                },
                tag_set: ["사색"],
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },
    {
        id: "1-6-2",
        title: "호러가면",
        msg: "아주 좋아! 크큭\n" +
            "즐거움만큼 즐거운 일은 없다고!",
        choice_set: [
            {
                title: "맞아요!",
                dom_animation: "fade_in",
                tag_set: ["유흥"],
                target: {
                    id: "4-11-0",
                }
            }
        ],
    },
    {
        id: "1-6-3",
        title: "호러가면",
        msg: "그래 그래...내 목표도\n" +
            "곧, 이뤄질거야\n" +
            "너를 통해서 말이지",
        choice_set: [
            {
                title: "무섭네요",
                dom_animation: "fade_in",
                weight: {
                    gentle: -1,
                    flex: -1,
                    forgive: -1,
                    patience: -1,
                },
                tag_set: ["성취"],
                target: {
                    id: "3-11-0",
                }
            }
        ],
    },
    {
        id: "1-6-4",
        title: "호러가면",
        msg: "피곤한가?\n" +
            "내가 완전한 휴식을...\n" +
            "선물해주지",
        choice_set: [
            {
                title: "됐어요",
                dom_animation: "fade_in",
                weight: {
                    gentle: 2,
                    flex: 2,
                    forgive: 2,
                    patience: 2,
                },
                tag_set: ["휴양"],
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },

    {
        id: "1-9-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "말도 안통하는 동물한테\n" +
            "말을 걸고 있는거냐?\n" +
            "어디 모자란거 아니냐?",
        choice_set: [
            {
                title: "동물 이라구요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-9-2"
                }
            },
            {
                title: "사람 인데요?",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "1-9-2"
                }
            },
            {
                title: "똑똑한데요?",
                dom_animation: "fade_in",
                target: {
                    id: "1-9-3"
                }
            },
        ]
    },
    {
        id: "1-9-1",
        title: "호러가면",
        msg: "그래, 딱 보면 모르냐!\n" +
            "눈알은 장식이냐!크큭",
        choice_set: [
            {
                title: "무시하기",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "1-9-2",
        title: "호러가면",
        msg: "(호러가면이 다가와 속삭인다.)\n" +
            "....\n" +
            "진짜 조심하는게 좋아요.\n" +
            "백작부인은 분위기 깨는걸 정말...\n" +
            "싫어한답니다.",
        choice_set: [
            {
                title: "알았어요",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "1-9-3",
        title: "호러가면",
        msg: "네가 똑똑하면 나는,!\n" +
            "나는 아인슈타인이다!! 크큭",
        choice_set: [
            {
                title: "그렇군요",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },

    {
        id: "1-10-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "적당한 기회가 있다면\n" +
            "나는 너를 반으로\n" +
            "접어버릴 수도 있을 것 같다.",
        choice_set: [
            {
                title: "앞으로 접나요?",
                dom_animation: "fade_in",
                bg_effect: "shake",
                target: {
                    id: "1-10-1"
                }
            },
            {
                title: "에이, 안 믿어요.",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                bg_effect: "shake",
                target: {
                    id: "1-10-2"
                }
            },
            {
                title: "죄송합니다.",
                dom_animation: "fade_in",
                effect: "eye_light",
                target: {
                    id: "1-10-3",
                }
            },
        ]
    },
    {
        id: "1-10-1",
        title: "호러가면",
        msg: "뒤로 접어버릴거다.\n" +
            "지금 당장 접어주마",
        choice_set: [
            {
                title: "아파요...",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-5-0"
                }
            }
        ],
    },
    {
        id: "1-10-2",
        title: "호러가면",
        msg: "거짓말인지 아닌지\n" +
            "확인해보시지!",
        choice_set: [
            {
                title: "아파! 놔줘!!",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-5-0"
                }
            }
        ],
    },
    {
        id: "1-10-3",
        title: "호러가면",
        msg: "마지막 기회야.\n" +
            "앞으로 조심하는게 좋을거야!",
        choice_set: [
            {
                title: "네.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-5-0"
                }
            }
        ],
    },

    {
        id: "1-11-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "그래! 그런걸 좋아하는 놈이 있다면,\n" +
            "당장이라도 잡아다가\n" +
            "반으로 접어버려야 한다.",
        choice_set: [
            {
                title: "맞습니다.",
                dom_animation: "fade_in",
                target: {
                    id: "1-11-1"
                }
            },
            {
                title: "굳이?",
                dom_animation: "fade_in",
                target: {
                    id: "1-11-2"
                }
            },
            {
                title: "참견 좀 하지 마세요.",
                dom_animation: "fade_in",
                target: {
                    id: "1-11-3"
                }
            },
        ]
    },
    {
        id: "1-11-1",
        title: "호러가면",
        msg: "크큭, 처음이다.\n" +
            "네 녀석과 통한 거",
        choice_set: [
            {
                title: "그렇군요",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },
    {
        id: "1-11-2",
        title: "호러가면",
        msg: "당연하다.\n" +
            "반드시\n" +
            "기필코",
        choice_set: [
            {
                title: "아,예",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },
    {
        id: "1-11-3",
        title: "호러가면",
        msg: "가엾은 녀석..\n" +
            "나중에 살려달라고 애걸복걸\n" +
            "후회해도 소용없다.",
        choice_set: [
            {
                title: "마음대로 하세요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },

    {
        id: "1-12-0",
        title: "호러가면",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "쓰잘데기 없이 고집 부리는\n" +
            "놈이 하나 있는데..\n" +
            "어떤 최후를 선물하는게 좋을까?",
        choice_set: [
            {
                title: "쓸쓸한 죽음",
                dom_animation: "fade_in",
                target: {
                    id: "1-12-1"
                }
            },
            {
                title: "빛도 없는 방",
                dom_animation: "fade_in",
                target: {
                    id: "1-12-2"
                }
            },
            {
                title: "알량한 용서",
                dom_animation: "fade_in",
                target: {
                    id: "1-12-3"
                }
            },
            {
                title: "주홍글씨",
                dom_animation: "fade_in",
                target: {
                    id: "1-12-4"
                }
            },
        ]
    },
    {
        id: "1-12-1",
        title: "호러가면",
        msg: "딱 좋아.\n" +
            "비명소리는 언제나 즐겁거든",
        choice_set: [
            {
                title: "네, 그렇죠...",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            }
        ],
    },
    {
        id: "1-12-2",
        title: "호러가면",
        msg: "아무것도 없는 방에\n" +
            "가둬두고 매일매일 괴롭히는 것도\n" +
            "볼 만 하겠군",
        choice_set: [
            {
                title: "그렇겠군요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            }
        ],
    },
    {
        id: "1-12-3",
        title: "호러가면",
        msg: "아무것도 없는 방에\n" +
            "네 놈은 역시...\n" +
            "아무런 재미도 없어",
        choice_set: [
            {
                title: "네",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            }
        ],
    },
    {
        id: "1-12-4",
        title: "호러가면",
        msg: "그런 시시한 선물은\n" +
            "딱 너같은 녀석에게 어울린다.",
        choice_set: [
            {
                title: "무시한다.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            }
        ],
    },

    {
        id: "1-end",
        title: "호러가면",
        dom_animation: "fade_in",
        msg: "가라!\n" +
            "썩 꺼져!",
        choice_set: [
            {
                title: "떠나기",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                }
            },
        ]
    }
];

const beast_mask_script_set = [
    {
        id: "2-0-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "심드렁한 눈으로 나를 바라 보는 것\n" +
            "같다.",
        choice_set: [
            {
                title: "내 소개를 해볼까",
                dom_animation: "fade_in",
                target: {
                    id: "2-0-1"
                }
            },
            {
                title: "쓰다듬어 볼까",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                bg_effect: "shake",
                target: {
                    id: "2-0-2"
                }
            },
            {
                title: "다음에 말걸어야지",
                dom_animation: "fade_in",
                target: {
                    id: "2-0-3"
                }
            },
        ]
    },
    {
        id: "2-0-1",
        title: "야수 탈",
        msg: "열심히 내 소개를 하는 동안\n" +
            "듣는 둥 마는 둥 하더니\n" +
            "고개를 끄덕였다.",
        choice_set: [
            {
                title: "그러고 마는건가?",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-1-0"
                }
            }
        ],
    },
    {
        id: "2-0-2",
        title: "야수 탈",
        msg: "귀여워 보이는 얼굴.\n" +
            "머리에 손을 가져다 대는 순간\n" +
            "거대한 이빨을 드러내 다칠 뻔 했다.",
        choice_set: [
            {
                title: "조심해야겠다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-1-0"
                }
            }
        ],
    },
    {
        id: "2-0-3",
        title: "야수 탈",
        msg: "별로 재미없는 타입이네.\n" +
            "나중에 말거는게 좋겠다.",
        choice_set: [
            {
                title: "다른 사람에게 말걸기",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-1-0"
                }
            }
        ],
    },

    {
        id: "2-1-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "말을 걸어봤지만 대답은 하지 않는다.\n" +
            "이 사람 정체가 뭘까?",
        choice_set: [
            {
                title: "말을 못하는 것 같다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-1-1"
                }
            },
            {
                title: "역할에 심취한 것 같다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-1-2"
                }
            },
            {
                title: "이 사람이 에클린 백작부인?",
                dom_animation: "fade_in",
                target: {
                    id: "2-1-3"
                }
            },
        ]
    },
    {
        id: "2-1-1",
        title: "야수 탈",
        msg: "\"속았네\"\n" +
            "어디선가 작게 소곤거리는 소리가\n" +
            "들렸다.",
        choice_set: [
            {
                title: "뭐지?",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "2-1-2",
        title: "야수 탈",
        msg: "음...문득 내가 쓴 가면은\n" +
            "뭔지 궁금해졌다.",
        choice_set: [
            {
                title: "물어볼까?",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "2-2-0"
                }
            }
        ],
    },
    {
        id: "2-1-3",
        title: "야수 탈",
        msg: "만약에 맞다면 백작부인은\n" +
            "정말 괴상한 취미를 가진 것 같다.",
        choice_set: [
            {
                title: "궁금하다.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "3-10-0",
                }
            }
        ],
    },

    {
        id: "2-2-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "내가 쓴 가면이 뭔지 물어보았는데,\n" +
            "기겁을 하고 고개를 돌려버린다.\n" +
            "낑낑거리는 모습이 안쓰럽다.",
        choice_set: [
            {
                title: "갑자기?",
                dom_animation: "fade_in",
                weight: {
                    beast_mask_step: 1,
                },
                target: {
                    id: "2-2-1"
                }
            },
            {
                title: "위로해줄까",
                dom_animation: "fade_in",
                weight: {
                    beast_mask_step: 1,
                },
                target: {
                    id: "2-2-2"
                }
            },
            {
                title: "다시 불러볼까?",
                dom_animation: "fade_in",
                weight: {
                    beast_mask_step: 1,
                },
                target: {
                    id: "2-2-3"
                }
            },
        ]
    },
    {
        id: "2-2-1",
        title: "야수 탈",
        msg: "왜 갑자기 저러는지는 모르겠지만,\n" +
            "안쓰러운 눈길을 보내 보았다.",
        choice_set: [
            {
                title: "안쓰러워",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "2-2-2",
        title: "야수 탈",
        msg: "손을 내밀어 털을 쓰다듬었다.\n" +
            "피하지 않고, 부드러운 털을 내어주었다.",
        choice_set: [
            {
                title: "부드럽다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "2-3-0"
                }
            }
        ],
    },
    {
        id: "2-2-3",
        title: "야수 탈",
        msg: "\"이봐요!\"\n" +
            "불러봤지만...\n" +
            "대답은 들을 수 없었다.",
        choice_set: [
            {
                title: "호러가면이 날 부른다.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "1-9-0",
                }
            }
        ],
    },

    {
        id: "2-3-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "가면의 모습이 좀 바뀐 것 같다.\n" +
            "그에게 무슨 일이 생긴걸까?",
        choice_set: [
            {
                title: "무슨일이 일이 생긴거죠?",
                dom_animation: "fade_in",
                weight: {
                    beast_mask_step: 1,
                },
                target: {
                    id: "2-3-1",
                }
            },
            {
                title: "가면 같은게 아닐지도...",
                dom_animation: "fade_in",
                weight: {
                    beast_mask_step: 1,
                },
                target: {
                    id: "2-3-2"
                }
            },
            {
                title: "귀여우면 됐지",
                dom_animation: "fade_in",
                weight: {
                    beast_mask_step: 1,
                },
                target: {
                    id: "2-3-3"
                },
            },
        ]
    },
    {
        id: "2-3-1",
        title: "야수 탈",
        msg: "역시 대답은 없는데,\n" +
            "또 말을 걸어버렸다.",
        choice_set: [
            {
                title: "이제 말 안 걸어야지",
                dom_animation: "fade_in",
                weight: {
                    patience: 1,
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "2-3-2",
        title: "야수 탈",
        msg: "\"가면 맞지롱\"\n" +
            "어디선가 작게 소곤거리는 소리가\n" +
            "들렸다.",
        choice_set: [
            {
                title: "뭐지?",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                },
                target: {
                    id: "4-12-0",
                }
            }
        ],
    },
    {
        id: "2-3-3",
        title: "야수 탈",
        msg: "엄청 귀여워졌다.\n" +
            "다른 존재가 되어버렸어!",
        choice_set: [
            {
                title: "좋다.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1,
                },
                tag_set: ["취향.큐트"],
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ]
    },

    {
        id: "2-4-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "묻는 말에 대답은 안할테고,\n" +
            "노래나 불러야겠다.",
        choice_set: [
            {
                title: "먼지가 되어",
                dom_animation: "fade_in",
                target: {
                    id: "2-4-1",
                },
            },
            {
                title: "예스 올 예스",
                dom_animation: "fade_in",
                target: {
                    id: "2-4-2",
                },
            },
            {
                title: "영재였지",
                dom_animation: "fade_in",
                target: {
                    id: "2-4-3",
                },
            },
            {
                title: "가지마가지마가지마",
                dom_animation: "fade_in",
                target: {
                    id: "2-4-4",
                },
            },
        ]
    },
    {
        id: "2-4-1",
        title: "야수 탈",
        msg: ".....\n" +
            "왜인지 같이 흥얼거리는 것 같다.",
        choice_set: [
            {
                title: "날아가야지.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1,
                },
                tag_set: ["음악취향.포크"],
                target: {
                    id: "0-select",
                    next_id: "2-5-0"
                }
            }
        ],
    },
    {
        id: "2-4-2",
        title: "야수 탈",
        msg: "얼핏 얼핏 노래에 맞춰\n" +
            "춤을 추는 것 같다.\n" +
            "좀 이상하다.",
        choice_set: [
            {
                title: "이상해",
                dom_animation: "fade_in",
                weight: {
                    flex: 1,
                },
                tag_set: ["음악취향.여돌"],
                target: {
                    id: "0-select",
                    next_id: "2-5-0"
                }
            }
        ],
    },
    {
        id: "2-4-3",
        title: "야수 탈",
        msg: ".....\n" +
            "왜인지 같이 흥얼거리는 것 같다.",
        choice_set: [
            {
                title: "선배였지.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                },
                tag_set: ["음악취향.K힙합"],
                target: {
                    id: "0-select",
                    next_id: "2-5-0"
                }
            }
        ],
    },
    {
        id: "2-4-4",
        title: "야수 탈",
        msg: "상당히 불쾌한 표정을\n" +
            "짓고있는 걸 보았다.",
        choice_set: [
            {
                title: "죄송합니다.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1,
                },
                tag_set: ["음악취향.발라드", "고음"],
                target: {
                    id: "1-10-0",
                }
            }
        ],
    },

    {
        id: "2-5-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "평안한 표정을 짓고 있다.\n" +
            "가면에 표정이 드러날 정도의 연기력\n" +
            "나는 지금 어떤 표정으로 보일까?",
        choice_set: [
            {
                title: "웃는 얼굴",
                dom_animation: "fade_in",
                target: {
                    id: "2-5-1"
                },
            },
            {
                title: "슬픈 얼굴",
                dom_animation: "fade_in",
                target: {
                    id: "2-5-2"
                },
            },
            {
                title: "화난 얼굴",
                dom_animation: "fade_in",
                target: {
                    id: "2-5-3"
                },
            },
            {
                title: "찡그린 얼굴",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "2-5-4"
                },
            },
        ]
    },
    {
        id: "2-5-1",
        title: "야수 탈",
        msg: "그래, 왠지 내 가면은\n" +
            "웃는 모습일 것 같다",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-6-0"
                }
            }
        ],
    },
    {
        id: "2-5-2",
        title: "야수 탈",
        msg: "그래, 난 가끔 슬플 땐\n" +
            "눈물을 흘리ㅈ1",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-6-0"
                }
            }
        ],
    },
    {
        id: "2-5-3",
        title: "야수 탈",
        msg: "꽤 화나 보이는 얼굴일지도 모르겠다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-6-0"
                }
            }
        ],
    },
    {
        id: "2-5-4",
        title: "야수 탈",
        msg: "여긴 정말 이상하다.\n" +
            "아주 불쾌한 장소야",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    patience: 1,
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "0-select",
                    next_id: "2-6-0"
                }
            }
        ],
    },

    {
        id: "2-6-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "여기 모인 사람들은 모조리\n" +
            "괴짜인 것 같다.\n" +
            "그러고면 나는 주변에서..",
        choice_set: [
            {
                title: "재밌는 친구 1등",
                dom_animation: "fade_in",
                target: {
                    id: "2-6-1"
                },
            },
            {
                title: "말그대로 평범",
                dom_animation: "fade_in",
                target: {
                    id: "2-6-2"
                },
            },
            {
                title: "표현력 대장",
                dom_animation: "fade_in",
                target: {
                    id: "2-6-3"
                },
            },
            {
                title: "조용한 친구",
                dom_animation: "fade_in",
                target: {
                    id: "2-6-4"
                },
            },
        ]
    },
    {
        id: "2-6-1",
        title: "야수 탈",
        msg: "음...역시 재미로 따지면\n" +
            "나를 따라오기 힘들다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                    next_id: "2-end"
                }
            }
        ],
    },
    {
        id: "2-6-2",
        title: "야수 탈",
        msg: "특별히 무슨 말을\n" +
            "들어본 적은 없는 것 같다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                    flex: 1,
                    forgive: 1,
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-end"
                }
            }
        ],
    },
    {
        id: "2-6-3",
        title: "야수 탈",
        msg: "마음 표현도 똑똑히 하고,\n" +
            "묘사력도 뛰어난 편이지",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    gentle: -1,
                    flex: -1,
                    forgive: -1,
                    patience: -1
                },
                target: {
                    id: "3-12-0",
                }
            }
        ],
    },
    {
        id: "2-6-4",
        title: "야수 탈",
        msg: "나는 좀 과묵한 편이다.\n" +
            "그게 편하다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    gentle: 2,
                    flex: 2,
                    forgive: 2,
                    patience: 2
                },
                target: {
                    id: "0-select",
                    next_id: "2-end"
                }
            }
        ],
    },

    {
        id: "2-9-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "갑자기 털복숭이가 배를 뒤집는다.\n" +
            "아니 얘는 갑자기 왜...",
        choice_set: [
            {
                title: "배를 만져준다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-9-1",
                },
            },
            {
                title: "옆으로 밀친다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-9-2",
                },
            },
            {
                title: "머리를 쓰다듬는다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-9-3",
                },
            },
        ]
    },
    {
        id: "2-9-1",
        title: "야수 탈",
        msg: "배 이야기가 나와서 그랬나,\n" +
            "진짜 이상한 사람같지만..\n" +
            "보드럽다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-5-0"
                }
            }
        ],
    },
    {
        id: "2-9-2",
        title: "야수 탈",
        msg: "이 사람 진짜 뭐야,\n" +
            "진짜 이상한 사람같아",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-5-0"
                }
            }
        ],
    },
    {
        id: "2-9-3",
        title: "야수 탈",
        msg: "귀여운 얼굴에 손을 대는 순간\n" +
            "거대한 이빨을 드러내어 놀랐다.\n" +
            "머리 만지는건 싫어하는 것 같다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                bg_effect: "shake",
                target: {
                    id: "0-select",
                    next_id: "1-5-0"
                }
            }
        ],
    },

    {
        id: "2-10-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "나를 보며 침을 흘린다.\n" +
            "설마 민트초코 때문인가..\n" +
            "갑자기 나도 배가 고파졌다.",
        choice_set: [
            {
                title: "집밥이 먹고싶다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-10-1"
                },
            },
            {
                title: "화려한 뷔페가 먹고싶다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-10-2"
                },
            },
            {
                title: "줄 서서 먹는 맛집을 가고싶다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-10-3"
                },
            },
            {
                title: "다이어트 중이니 참자..",
                dom_animation: "fade_in",
                target: {
                    id: "2-10-4"
                },
            },
        ]
    },
    {
        id: "2-10-1",
        title: "야수 탈",
        msg: "생각해보니 만찬음식이 아직\n" +
            "나오지 않았다.\n" +
            "그래봐야 집밥은 없겠지만",
        choice_set: [
            {
                title: "배고프다",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                tag_set: ["집밥"],
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },
    {
        id: "2-10-2",
        title: "야수 탈",
        msg: "아, 여기 만찬모임이지!\n" +
            "어서 먹고 싶다..",
        choice_set: [
            {
                title: "배고프다",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                tag_set: ["뷔페"],
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },
    {
        id: "2-10-3",
        title: "야수 탈",
        msg: "그러고 보니 만찬 모임인데..\n" +
            "기대되는군 메인요리는\n" +
            "어떤 맛일런지..",
        choice_set: [
            {
                title: "배고프다",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                tag_set: ["맛집"],
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },
    {
        id: "2-10-4",
        title: "야수 탈",
        msg: "속이 쓰리다.\n" +
            "어차피 죽으면 흙이 될텐데\n" +
            "나는 왜 다이어트를 하는가.",
        choice_set: [
            {
                title: "배고프다",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                tag_set: ["다이어트"],
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },

    {
        id: "2-11-0",
        title: "야수 탈",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "갑자기 이글거리는 눈 빛으로\n" +
            "나를 쳐다본다.",
        choice_set: [
            {
                title: "경계하는 건가?",
                dom_animation: "fade_in",
                target: {
                    id: "2-11-1"
                },
            },
            {
                title: "배가 고픈가?",
                dom_animation: "fade_in",
                target: {
                    id: "2-11-2"
                },
            },
            {
                title: "무시한다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-11-3"
                },
            },
            {
                title: "말 걸어본다.",
                dom_animation: "fade_in",
                target: {
                    id: "2-11-4"
                },
            },
        ]
    },
    {
        id: "2-11-1",
        title: "야수 탈",
        msg: "맹수의 촉 같은걸까?\n" +
            "나를 경계하는 눈 빛이다.",
        choice_set: [
            {
                title: "시건방지군",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            }
        ],
    },
    {
        id: "2-11-2",
        title: "야수 탈",
        msg: "내가 먹잇감으로 보이는 건가.\n" +
            "이상한 사람이다.",
        choice_set: [
            {
                title: "불쾌해",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            }
        ],
    },
    {
        id: "2-11-3",
        title: "야수 탈",
        msg: "눈을 마주치지 않는게\n" +
            "좋을 것 같다.\n" +
            "엮이면 피곤할 것 같다.",
        choice_set: [
            {
                title: "시선 피하기",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            }
        ],
    },
    {
        id: "2-11-4",
        title: "야수 탈",
        msg: "말을 걸어봤지만,\n" +
            "눈을 돌려버린다.",
        choice_set: [
            {
                title: "뭐지 대체?",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            }
        ],
    },

    {
        id: "2-end",
        title: "야수 탈",
        dom_animation: "fade_in",
        msg: "말을 걸어봤는데 무시한다.",
        choice_set: [
            {
                title: "떠나기",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                }
            },
        ]
    },
];

const royal_mask_script_set = [
    {
        id: "3-0-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "만나서 반갑네.\n" +
            "본인에게 무슨 용무 있는가?",
        choice_set: [
            {
                title: "초장부터 반말이세요?",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "3-0-1",
                },
            },
            {
                title: "가면이 멋지네요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-0-2",
                },
            },
            {
                title: "누구시죠?",
                dom_animation: "fade_in",
                target: {
                    id: "3-0-3",
                },
            },
        ]
    },
    {
        id: "3-0-1",
        title: "귀족 마스크",
        msg: "허허, 에클린 백작부인의 만찬에서는\n" +
            "자신이 쓴 가면의 역할을 제대로\n" +
            "수행해주는 편이 신상에 좋다네.",
        choice_set: [
            {
                title: "그 것도 반말이잖아요",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "3-2-0"
                }
            }
        ],
    },
    {
        id: "3-0-2",
        title: "귀족 마스크",
        msg: "허허, 본인의 감각을 알아보다니,\n" +
            "공은 심미안을 가졌군!",
        choice_set: [
            {
                title: "제 가면은 어떤가요?",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "3-7-0",
                }
            }
        ],
    },
    {
        id: "3-0-3",
        title: "귀족 마스크",
        msg: "본인은 드넓은 평야를\n" +
            "다스리고 있다네.\n" +
            "백작부인과는 오래 알고 지냈지",
        choice_set: [
            {
                title: "아! 그렇군요!",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },

    {
        id: "3-2-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "나는 원래 성격이 이렇다네.\n" +
            "아주 잘 맞는 가면이지.",
        choice_set: [
            {
                title: "제 가면은 어떤 모양인가요?",
                dom_animation: "fade_in",
                target: {
                    id: "3-2-1",
                },
            },
            {
                title: "저랑은 잘 안 맞는 것 같네요.",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "3-2-2",
                },
            },
            {
                title: "그러게요 잘 어울려요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-2-3",
                },
            },
        ]
    },
    {
        id: "3-2-1",
        title: "귀족 마스크",
        msg: "글쎄, 가만히 있어보게나\n" +
            "본인이 자세히 보고 말해줄테니",
        choice_set: [
            {
                title: "가만히 있기",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "3-2-2",
        title: "귀족 마스크",
        msg: "그래요. 그럽시다. 괜히 엮였다가\n" +
            "나까지 피해입고 싶진 않으니...",
        choice_set: [
            {
                title: "잘 생각했어요",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },
    {
        id: "3-2-3",
        title: "귀족 마스크",
        msg: "공의 말투에서 높은 학식이 느껴지는군\n" +
            "근래에 보기드문 교양있는 청년일세.",
        choice_set: [
            {
                title: "고마워요",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "4-13-0",
                }
            }
        ],
    },

    {
        id: "3-3-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "본인은 불의를 참지 못하는 치라네.\n" +
            "공은 어떤가?",
        choice_set: [
            {
                title: "절대 못 참죠.",
                dom_animation: "fade_in",
                target: {
                    id: "3-3-1",
                },
            },
            {
                title: "참는 편이죠.",
                dom_animation: "fade_in",
                target: {
                    id: "3-3-2",
                },
            },
            {
                title: "그 때 그 때 달라요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-3-3",
                },
            },
        ]
    },
    {
        id: "3-3-1",
        title: "귀족 마스크",
        msg: "장군감이로구만,\n" +
            "만찬이 끝나면 내 좋은 자리를\n" +
            "알아봐줌세",
        choice_set: [
            {
                title: "어떤 자리죠?",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                tag_set: ["정의감"],
                target: {
                    id: "3-4-0"
                }
            }
        ],
    },
    {
        id: "3-3-2",
        title: "귀족 마스크",
        msg: "공은 깨달아야 한다네!\n" +
            "그 어떤 불의도 참아서는\n" +
            "안된다는 사실을 말일세!",
        choice_set: [
            {
                title: "그래요...",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-5-0"
                }
            }
        ],
    },
    {
        id: "3-3-3",
        title: "귀족 마스크",
        msg: "용기를 내기 어려운 순간이\n" +
            "언제든 있을 수 있다네.\n" +
            "그럼에도 불구하고 불의를\n" +
            "참아선 안된다네!",
        choice_set: [
            {
                title: "노력해볼게요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-5-0"
                }
            }
        ],
    },

    {
        id: "3-4-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "글쎄, 어떤 자리가 좋겠는가?\n" +
            "공이 한 번 골라보게나.",
        choice_set: [
            {
                title: "정부기관",
                dom_animation: "fade_in",
                target: {
                    id: "3-4-1",
                },
            },
            {
                title: "산업기관",
                dom_animation: "fade_in",
                target: {
                    id: "3-4-2",
                },
            },
            {
                title: "연구기관",
                dom_animation: "fade_in",
                target: {
                    id: "3-4-3",
                },
            },
            {
                title: "군사기관",
                dom_animation: "fade_in",
                target: {
                    id: "3-4-4",
                },
            },
        ]
    },
    {
        id: "3-4-1",
        title: "귀족 마스크",
        msg: "오, 마침 좋은 자리가 있는데,\n" +
            "나중에 소개시켜주겟네",
        choice_set: [
            {
                title: "감사합니다!",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-5-0"
                }
            }
        ],
    },
    {
        id: "3-4-2",
        title: "귀족 마스크",
        msg: "오, 마침 좋은 자리가 있는데,\n" +
            "나중에 소개시켜주겟네",
        choice_set: [
            {
                title: "감사합니다!",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-5-0"
                }
            }
        ],
    },
    {
        id: "3-4-3",
        title: "귀족 마스크",
        msg: "오, 마침 좋은 자리가 있는데,\n" +
            "나중에 소개시켜주겟네",
        choice_set: [
            {
                title: "감사합니다!",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-5-0"
                }
            }
        ],
    },
    {
        id: "3-4-4",
        title: "귀족 마스크",
        msg: "용맹한 자로군 역시!\n" +
            "아주 마음에 들어\n" +
            "본인이 반드시 추천하겠네!",
        choice_set: [
            {
                title: "감사합니다!",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-5-0"
                }
            }
        ],
    },

    {
        id: "3-5-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "요즘 젊은이들은\n" +
            "민트초코라는 음식을 좋아한다는군?\n" +
            "자네는 어떻게 생각하는가?",
        choice_set: [
            {
                title: "새로운 트랜드죠.",
                dom_animation: "fade_in",
                target: {
                    id: "3-5-1",
                },
            },
            {
                title: "절대 이해 못 하죠.",
                dom_animation: "fade_in",
                target: {
                    id: "3-5-2",
                },
            },
            {
                title: "아무생각 없어요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-5-3",
                },
            },
        ]
    },
    {
        id: "3-5-1",
        title: "귀족 마스크",
        msg: "격세지감이로다.",
        choice_set: [
            {
                title: "그러게요",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                tag_set: ["민트초코"],
                target: {
                    id: "2-10-0",
                }
            }
        ],
    },
    {
        id: "3-5-2",
        title: "귀족 마스크",
        msg: "그래, 새로운 것은 언제나 생소하지.\n" +
            "그럼에도 불구하고 도전을 멈춰선\n" +
            "안된다네",
        choice_set: [
            {
                title: "맛은 봤어요...",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "1-11-0",
                }
            }
        ],
    },
    {
        id: "3-5-3",
        title: "귀족 마스크",
        msg: "공은 깊이 생각하는 편은 아닌가보군,\n" +
            "꾸밈없는 솔직함은 마음에 든다네.",
        choice_set: [
            {
                title: "하하, 감사합니다.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-6-0"
                }
            }
        ],
    },

    {
        id: "3-6-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "우아한 음악을 들을 때 본인은\n" +
            "형언할 수 없는 감동을 느낀다네.\n" +
            "공은 어떨때 기분이 고조되는가?",
        choice_set: [
            {
                title: "운동과 액티비티",
                dom_animation: "fade_in",
                target: {
                    id: "3-6-1",
                },
            },
            {
                title: "독서와 영화감상",
                dom_animation: "fade_in",
                target: {
                    id: "3-6-2",
                },
            },
            {
                title: "음악감상과 커피",
                dom_animation: "fade_in",
                target: {
                    id: "3-6-3",
                },
            },
            {
                title: "글 쓰기와 그리기",
                dom_animation: "fade_in",
                target: {
                    id: "3-6-4",
                },
            },
        ]
    },
    {
        id: "3-6-1",
        title: "귀족 마스크",
        msg: "보기드문 훌륭한 정신일세.\n" +
            "체력이 곧 국력이니 말일세.",
        choice_set: [
            {
                title: "과찬이십니다.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                tag_set: ["취미.액티비티"],
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },
    {
        id: "3-6-2",
        title: "귀족 마스크",
        msg: "공은 역시 우아한 취미를 가졌군\n" +
            "따뜻한 지성이야말로\n" +
            "세상을 이끌 수 있다네",
        choice_set: [
            {
                title: "공감합니다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                tag_set: ["취미.독서", "취미.영화감상"],
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },
    {
        id: "3-6-3",
        title: "귀족 마스크",
        msg: "오, 만약 뜻이 맞다면\n" +
            "공과 커피취향을 공유해보고 싶네만!",
        choice_set: [
            {
                title: "좋습니다~!",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                tag_set: ["취미.음악감상"],
                target: {
                    id: "3-8-0",
                }
            }
        ],
    },
    {
        id: "3-6-4",
        title: "귀족 마스크",
        msg: "언제 한번 공의 작품을\n" +
            "내 두 눈으로 직접\n" +
            "감상해보고 싶구만",
        choice_set: [
            {
                title: "부끄럽네요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                tag_set: ["취미.글쓰기", "취미.그림그리기"],
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },

    {
        id: "3-7-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "역할극은 처음인가?\n" +
            "아직 가면이 조금 불편해보이는군.\n" +
            "걱정말게나 곧 멋진 형태가 될 것이네",
        choice_set: [
            {
                title: "우아한 가면이었으면..",
                dom_animation: "fade_in",
                target: {
                    id: "3-7-1",
                },
            },
            {
                title: "캐릭터 가면이었으면...",
                dom_animation: "fade_in",
                target: {
                    id: "3-7-2",
                },
            },
            {
                title: "털뭉치 가면이었으면...",
                dom_animation: "fade_in",
                target: {
                    id: "3-7-3",
                },
            },
            {
                title: "신기한 가면이었으면...",
                dom_animation: "fade_in",
                target: {
                    id: "3-7-4",
                },
            },
        ]
    },
    {
        id: "3-7-1",
        title: "귀족 마스크",
        msg: "그래 공이 원하는 모습의\n" +
            "가면을 곧 가지게 될걸세",
        choice_set: [
            {
                title: "감사합니다",
                dom_animation: "fade_in",
                weight: {
                    gentle: -1,
                    flex: -1,
                    forgive: -1,
                    patience: -1
                },
                tag_set: ["취향.럭셔리"],
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "3-7-2",
        title: "귀족 마스크",
        msg: "그래 공이 원하는 모습의\n" +
            "가면을 곧 가지게 될걸세",
        choice_set: [
            {
                title: "감사합니다",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "3-7-3",
        title: "귀족 마스크",
        msg: "그래 공이 원하는 모습의\n" +
            "가면을 곧 가지게 될걸세",
        choice_set: [
            {
                title: "감사합니다",
                dom_animation: "fade_in",
                weight: {
                    gentle: 2,
                    flex: 2,
                    forgive: 2,
                    patience: 2
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "3-7-4",
        title: "귀족 마스크",
        msg: "그래 공이 원하는 모습의\n" +
            "가면을 곧 가지게 될걸세",
        choice_set: [
            {
                title: "감사합니다",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                    flex: 1,
                    forgive: 1,
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },

    {
        id: "3-8-0",
        title: "귀족 마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "가만 있어보게나\n" +
            "공은 어떤 커피를 즐기는가?",
        choice_set: [
            {
                title: "씁쓸한 인생 맛 커피",
                dom_animation: "fade_in",
                target: {
                    id: "3-8-1",
                },
            },
            {
                title: "가볍고 달달한 커피",
                dom_animation: "fade_in",
                target: {
                    id: "3-8-2",
                },
            },
            {
                title: "뭐 든지 좋아요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-8-3",
                },
            },
            {
                title: "커피보다는 대화",
                dom_animation: "fade_in",
                target: {
                    id: "3-8-4",
                },
            },
        ]
    },
    {
        id: "3-8-1",
        title: "귀족 마스크",
        msg: "이런 말이 있지.\n" +
            "커피는 지옥보다 검고\n" +
            "죽음보다 쓴 맛이라고...",
        choice_set: [
            {
                title: "물론입니다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: -1,
                    flex: -1,
                    forgive: -1,
                    patience: -1
                },
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },
    {
        id: "3-8-2",
        title: "귀족 마스크",
        msg: "그래, 본인은 이해한다네.\n" +
            "그 누구보다 다양성을 존중하니까\n" +
            "말일세...",
        choice_set: [
            {
                title: "(혀를 쯧쯧 찬 거 같은데..)",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },
    {
        id: "3-8-3",
        title: "귀족 마스크",
        msg: "그래, 본인은 이해한다네.\n" +
            "그 누구보다 다양성을 존중하니까\n" +
            "말일세...",
        choice_set: [
            {
                title: "(혀를 쯧쯧 찬 거 같은데..)",
                dom_animation: "fade_in",
                weight: {
                    gentle: 2,
                    flex: 2,
                    forgive: 2,
                    patience: 2
                },
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },
    {
        id: "3-8-4",
        title: "귀족 마스크",
        msg: "커피도 중요하지만, 본질은\n" +
            "대화를 나누는 데에 있다는 것인가?\n" +
            "역시 공은 알수록 깊은 이로구만..",
        choice_set: [
            {
                title: "과찬입니다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                    flex: 1,
                    forgive: 1,
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-end"
                }
            }
        ],
    },

    {
        id: "3-9-0",
        title: "귀족마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "보기 좋은 얼굴을 하고 있군.\n" +
            "본인만큼은 아니지만,\n" +
            "그래도 훌륭한 모습일세!",
        choice_set: [
            {
                title: "조금 올드한가요?",
                dom_animation: "fade_in",
                target: {
                    id: "3-9-1",
                }
            },
            {
                title: "좀 화려한가요?",
                dom_animation: "fade_in",
                target: {
                    id: "3-9-2",
                }
            },
            {
                title: "너무 특징없나요?",
                dom_animation: "fade_in",
                target: {
                    id: "3-9-3",
                }
            },
            {
                title: "이상한가요?",
                dom_animation: "fade_in",
                target: {
                    id: "3-9-4",
                }
            },
        ]
    },
    {
        id: "3-9-1",
        title: "귀족마스크",
        msg: "글쎄...잘 모르겠네\n" +
            "처음보는 형태라서 말이야.",
        choice_set: [
            {
                title: "알겠습니다.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },
    {
        id: "3-9-2",
        title: "귀족마스크",
        msg: "글쎄...얼핏 보면,\n" +
            "화려한 것 같지만 또...\n" +
            "어찌 보면 그런것 같지도 않구만",
        choice_set: [
            {
                title: "알겠습니다.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },
    {
        id: "3-9-3",
        title: "귀족마스크",
        msg: "음......\n" +
            "뭐라 특정지어 말하기 어렵군",
        choice_set: [
            {
                title: "알겠습니다.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },
    {
        id: "3-9-4",
        title: "귀족마스크",
        msg: "아닐세,\n" +
            "이상한건 전혀 아니고 뭐라할지...\n" +
            "표현하기 어렵군",
        choice_set: [
            {
                title: "알겠습니다.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-4-0"
                }
            }
        ],
    },

    {
        id: "3-10-0",
        title: "귀족마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "에클린 백작부인에 대해 궁금한가?\n" +
            "딱 한가지만 알려주겠네.\n" +
            "무엇이 궁금한가?",
        choice_set: [
            {
                title: "백작부인의 얼굴",
                dom_animation: "fade_in",
                target: {
                    id: "3-10-1"
                },
            },
            {
                title: "백작부인의 취미",
                dom_animation: "fade_in",
                target: {
                    id: "3-10-2"
                },
            },
            {
                title: "백작부인의 가족",
                dom_animation: "fade_in",
                target: {
                    id: "3-10-3"
                },
            },
            {
                title: "백작부인의 성격",
                dom_animation: "fade_in",
                target: {
                    id: "3-10-4"
                },
            },
        ]
    },
    {
        id: "3-10-1",
        title: "귀족마스크",
        msg: "답할 수 없는 질문이네.\n" +
            "백작부인은 얼굴에 대해\n" +
            "이야기하는걸 그리 좋아하지 않는다네,",
        choice_set: [
            {
                title: "(다 물어보라면서...)",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "3-10-2",
        title: "귀족마스크",
        msg: "백작부인의 취미는 당연히\n" +
            "가면무도회라네. 그 중에서도\n" +
            "역할극을 가장 좋아하지.",
        choice_set: [
            {
                title: "그래서 이 모임을...",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "3-10-3",
        title: "귀족마스크",
        msg: "음, 그건 본인도 잘 모른다네\n" +
            "있다가 만나게 된다면 직접\n" +
            "물어보는 것은 어떤가?",
        choice_set: [
            {
                title: "알겠습니다.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "3-10-4",
        title: "귀족마스크",
        msg: "내가 아는 모든이들중에\n" +
            "가장 높은 학식과\n" +
            "교양을 갖춘 분이라네",
        choice_set: [
            {
                title: "그런 분이군요.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },

    {
        id: "3-11-0",
        title: "귀족마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "지저분한 과면과\n" +
            "격 떨어지는 대화는 관두게\n" +
            "목표를 추구하는건 아주\n" +
            "고귀한 일이니까 말이네",
        choice_set: [
            {
                title: "과찬입니다.",
                dom_animation: "fade_in",
                target: {
                    id: "3-11-1"
                },
            },
            {
                title: "귀족마스크님의 목표는 뭔가요?",
                dom_animation: "fade_in",
                target: {
                    id: "3-11-2"
                },
            },
            {
                title: "부담스럽네요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-11-3"
                },
            },
        ]
    },
    {
        id: "3-11-1",
        title: "귀족마스크",
        msg: "공은 겸손하기 까지 하군,\n" +
            "나야말로 본받아야겠어!",
        choice_set: [
            {
                title: "하하",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },
    {
        id: "3-11-2",
        title: "귀족마스크",
        msg: "음. 글쎄, 일단은 이 자리를\n" +
            "\"무사히\"즐기는 것 정도로 해두지",
        choice_set: [
            {
                title: "그렇군요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },
    {
        id: "3-11-3",
        title: "귀족마스크",
        msg: "저런..\n" +
            "칭찬을 받아들이는 것도\n" +
            "하나의 미덕이라네",
        choice_set: [
            {
                title: "알겠습니다.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },

    {
        id: "3-12-0",
        title: "귀족마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "그래, 멋진 표현이야 말로\n" +
            "드넓은 세상의 이치를 설명하는\n" +
            "가장 중요한 가치라네!",
        choice_set: [
            {
                title: "라임이 좋군요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-12-1"
                },
            },
            {
                title: "알아봐주시니 감사합니다.",
                dom_animation: "fade_in",
                target: {
                    id: "3-12-2"
                },
            },
            {
                title: "부담스럽네요.",
                dom_animation: "fade_in",
                target: {
                    id: "3-12-3"
                },
            },
        ]
    },
    {
        id: "3-12-1",
        title: "귀족마스크",
        msg: "라임이 뭔가?\n" +
            "자네 설마 과일 '라임'을\n" +
            "이야기하는겐가?",
        choice_set: [
            {
                title: "(진짜 컨셉특이하네)",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-end"
                }
            }
        ],
    },
    {
        id: "3-12-2",
        title: "귀족마스크",
        msg: "이 뜻에 공감하는 이가있어.\n" +
            "본인 또한 아주 감격스럽네!",
        choice_set: [
            {
                title: "하하!",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-end"
                }
            }
        ],
    },
    {
        id: "3-12-3",
        title: "귀족마스크",
        msg: "저런, 부담갖지 말게나.\n" +
            "공은 충분히 대우받을\n" +
            "자격이 있다네",
        choice_set: [
            {
                title: "감사합니다!",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-end"
                }
            }
        ],
    },

    {
        id: "3-13-0",
        title: "귀족마스크",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "역시 공은 감각이 아주 뛰어나!\n" +
            "가장 마음에 들었던\n" +
            "작품을 물어봐도 되겠나?",
        choice_set: [
            {
                title: "성모와 예수",
                dom_animation: "fade_in",
                target: {
                    id: "3-13-1"
                },
            },
            {
                title: "근육질 무용수",
                dom_animation: "fade_in",
                target: {
                    id: "3-13-2"
                },
            },
            {
                title: "포효하는 사자",
                dom_animation: "fade_in",
                target: {
                    id: "3-13-3"
                },
            },
            {
                title: "뒤얽힌 군중",
                dom_animation: "fade_in",
                target: {
                    id: "3-13-4"
                },
            },
        ]
    },
    {
        id: "3-13-1",
        title: "귀족마스크",
        msg: "그렇다네.\n" +
            "보고있노라면 그 숭고함에\n" +
            "눈물이 맺힐 지경이네",
        choice_set: [
            {
                title: "그런가요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            }
        ],
    },
    {
        id: "3-13-2",
        title: "귀족마스크",
        msg: "오, 저 어깨로부터\n" +
            "손목까지 내려오는 무관심한\n" +
            "선을 보게나!",
        choice_set: [
            {
                title: "대단합니다.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            }
        ],
    },
    {
        id: "3-13-3",
        title: "귀족마스크",
        msg: "당장이라도 우렁찬\n" +
            "야생의 함성이 들려올\n" +
            "것 같지 않는가?",
        choice_set: [
            {
                title: "...들립니다.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            }
        ],
    },
    {
        id: "3-13-4",
        title: "귀족마스크",
        msg: "복잡한 인체가 마구 엉키니,\n" +
            "거대한 평면같이 보이는구먼,\n" +
            "관능, 혐오, 질투 모든게 녹아있네.",
        choice_set: [
            {
                title: "멋진 표현이네요.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            }
        ],
    },

    {
        id: "3-end",
        title: "귀족 마스크",
        dom_animation: "fade_in",
        msg: "지금은 매우 바쁘다네.\n " +
            "나중에 찾아오시게나",
        choice_set: [
            {
                title: "떠나기",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                }
            },
        ]
    },
];

const mystery_mask_script_set = [
    {
        id: "4-0-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "반가워요 친구.\n" +
            "우주의 신비를 전하러 온 전달자에요.\n" +
            "무엇이 궁금한가요?",
        choice_set: [
            {
                title: "당신은 친절하군요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-0-1",
                },
            },
            {
                title: "우주의 신비가 뭔가요?",
                dom_animation: "fade_in",
                target: {
                    id: "4-0-2",
                },
            },
            {
                title: "만찬은 처음인가요?",
                dom_animation: "fade_in",
                target: {
                    id: "4-0-3",
                },
            },
        ]
    },
    {
        id: "4-0-1",
        title: "신비로운 분장",
        msg: "가까운 이를 소중하게 대하는게\n" +
            "첫번 째 신비의 시작이지요.",
        choice_set: [
            {
                title: "재미있네요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-1-0"
                }
            },
        ]
    },
    {
        id: "4-0-2",
        title: "신비로운 분장",
        msg: "신비는 가까운 이를 소중하게 대하는 마음\n" +
            "거기서부터 시작한답니다.",
        choice_set: [
            {
                title: "맞는듯요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-1-0"
                }
            },
        ]
    },
    {
        id: "4-0-3",
        title: "신비로운 분장",
        msg: "네 처음이에요.\n" +
            "그래도 이정도면 꽤 좋은 연기력이죠?",
        choice_set: [
            {
                title: "그러네요. 저도 처음이에요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "4-2-0",
                }
            },
        ]
    },

    {
        id: "4-1-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "여기 너무 마음에 드네요.\n" +
            "아!...\n" +
            "당신에 대해서 말해줄래요?",
        choice_set: [
            {
                title: "산과 나무 같아요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-1-1",
                },
            },
            {
                title: "루비와 토파즈 처럼 빛나요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-1-2",
                },
            },
            {
                title: "깊은 꿈과 짙은 그림자",
                dom_animation: "fade_in",
                target: {
                    id: "4-1-3",
                },
            },
            {
                title: "사납고 용맹한 맹수",
                dom_animation: "fade_in",
                target: {
                    id: "4-1-4",
                },
            },
        ]
    },
    {
        id: "4-1-1",
        title: "신비로운 분장",
        msg: "변하지 않는 마음. 그리고...\n" +
            "상쾌한 안식처가 떠오르는군요.",
        choice_set: [
            {
                title: "그렇군요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            },
        ]
    },
    {
        id: "4-1-2",
        title: "신비로운 분장",
        msg: "금은보화로도 대체할 수 없는\n" +
            "반짝이는 성품을 가진 분...\n" +
            "정도로 이해하면 될까요?",
        choice_set: [
            {
                title: "네",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            },
        ]
    },
    {
        id: "4-1-3",
        title: "신비로운 분장",
        msg: "종 잡을 수 없는\n" +
            "태고의 매력을 간직한\n" +
            "그런 사람이군요-!",
        choice_set: [
            {
                title: "멋진 표현인데요?",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-3-0"
                }
            },
        ]
    },
    {
        id: "4-1-4",
        title: "신비로운 분장",
        msg: "늠름하고 멋지네요.\n" +
            "그 눈동자에 맺힌 상냥함까지요.",
        choice_set: [
            {
                title: "감사합니다",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "2-11-0",
                }
            },
        ]
    },

    {
        id: "4-2-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "앗 당신도 처음이신가요?\n" +
            "아까 얼핏 들었는데...\n" +
            "백작부인은 사실 마녀래요!",
        choice_set: [
            {
                title: "말도 안 돼요!",
                dom_animation: "fade_in",
                target: {
                    id: "4-2-1",
                },
            },
            {
                title: "그게 어때서요?",
                dom_animation: "fade_in",
                target: {
                    id: "4-2-2",
                },
            },
            {
                title: "자세히 말해주세요!",
                dom_animation: "fade_in",
                weight: {
                    health: -1
                },
                effect: "blood",
                target: {
                    id: "4-2-3",
                },
            },
        ]
    },
    {
        id: "4-2-1",
        title: "신비로운 분장",
        msg: "역시 그렇죠?\n" +
            "제가 잘 못 들은거겠죠?",
        choice_set: [
            {
                title: "그런 것 같아요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-1-0"
                }
            },
        ]
    },
    {
        id: "4-2-2",
        title: "신비로운 분장",
        msg: "아! 맞아요!\n" +
            "그게 뭐 어때요~!",
        choice_set: [
            {
                title: "그렇죠.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-1-0"
                }
            },
        ]
    },
    {
        id: "4-2-3",
        title: "신비로운 분장",
        msg: "그녀의 기분을 상하게 하면...\n" +
            "산채로 잡아 먹는다고 하더군요.",
        choice_set: [
            {
                title: "설마요..",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },

    {
        id: "4-3-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "이 곳 너무 아름답지 않나요?\n" +
            "신비로움마저 느껴진답니다.\n" +
            "당신은 어떤 점이 마음에 드나요?",
        choice_set: [
            {
                title: "행복한 맛의 초콜렛 분수",
                dom_animation: "fade_in",
                target: {
                    id: "4-3-1",
                },
            },
            {
                title: "웅장한 바로크풍 조각",
                dom_animation: "fade_in",
                target: {
                    id: "4-3-2",
                },
            },
            {
                title: "담소를 나누기 좋은 정원",
                dom_animation: "fade_in",
                target: {
                    id: "4-3-3",
                },
            },
            {
                title: "마음에 드는 곳이 없어요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-3-4",
                },
            },
        ]
    },
    {
        id: "4-3-1",
        title: "신비로운 분장",
        msg: "달달한 초콜렛!\n" +
            "한 입 찍어먹으면,\n" +
            "우주 끝 까지 기분이 좋아지지요.",
        choice_set: [
            {
                title: "행복해요.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            },
        ]
    },
    {
        id: "4-3-2",
        title: "신비로운 분장",
        msg: "정말 대리석으로 만들었을까요?\n" +
            "어쩌면, 사람이 돌로 변한 건\n" +
            "아닐까 생각하게 되네요.",
        choice_set: [
            {
                title: "그렇네요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "3-13-0",
                }
            },
        ]
    },
    {
        id: "4-3-3",
        title: "신비로운 분장",
        msg: "조화로운 조경도 좋았지만,\n" +
            "온갖 새들이 지저귀는 모습에\n" +
            "완전히 반했어요!",
        choice_set: [
            {
                title: "저도 그래요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            },
        ]
    },
    {
        id: "4-3-4",
        title: "신비로운 분장",
        msg: "그렇군요.\n" +
            "그럴 수 도 있죠!",
        choice_set: [
            {
                title: "그렇죠.",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                    next_id: "4-4-0"
                }
            },
        ]
    },

    {
        id: "4-4-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "저는 대부분의 사람들을 좋아해요.\n" +
            "그런데 자기만 아는 사람은\n" +
            "정말 질색팔색이에요.\n" +
            "당신은 어떤 성격을 싫어하죠?",
        choice_set: [
            {
                title: "이기주의자",
                dom_animation: "fade_in",
                target: {
                    id: "4-4-1",
                },
            },
            {
                title: "옹고집",
                dom_animation: "fade_in",
                target: {
                    id: "4-4-2",
                },
            },
            {
                title: "분노조절장애",
                dom_animation: "fade_in",
                target: {
                    id: "4-4-3",
                },
            },
            {
                title: "매사 부정맨",
                dom_animation: "fade_in",
                target: {
                    id: "4-4-4",
                },
            },
        ]
    },
    {
        id: "4-4-1",
        title: "신비로운 분장",
        msg: "저랑 같군요.\n" +
            "진짜 너무 싫어요!\n" +
            "우주의 신비에 어긋나!",
        choice_set: [
            {
                title: "그렇죠.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            },
        ]
    },
    {
        id: "4-4-2",
        title: "신비로운 분장",
        msg: "그러게요 쓸데없는\n" +
            "고집을 부려서는 무엇도\n" +
            "얻을 수 없는데말이죠!",
        choice_set: [
            {
                title: "맞아요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "1-12-0",
                }
            },
        ]
    },
    {
        id: "4-4-3",
        title: "신비로운 분장",
        msg: "우주의 신비에 통달한 제게도\n" +
            "종종 분노가 찾아온답니다.\n" +
            "저런 사람들을 볼 때요.",
        choice_set: [
            {
                title: "그렇군요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            },
        ]
    },
    {
        id: "4-4-4",
        title: "신비로운 분장",
        msg: "매사에 부정적인 이들의\n" +
            "감정은 서서히 어둠으로 잠식돼요.\n" +
            "블랙홀 처럼요.",
        choice_set: [
            {
                title: "그렇군요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-5-0"
                }
            },
        ]
    },

    {
        id: "4-5-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "저는 모든 우주의 신비를\n" +
            "알고 있어요. 궁금한게 있다면\n" +
            "알려드릴게요!",
        choice_set: [
            {
                title: "모든 것을 흡수하는 블랙홀",
                dom_animation: "fade_in",
                target: {
                    id: "4-5-1",
                },
            },
            {
                title: "별을 잇는 은하수",
                dom_animation: "fade_in",
                target: {
                    id: "4-5-2",
                },
            },
            {
                title: "외계인이 사는 이야기",
                dom_animation: "fade_in",
                target: {
                    id: "4-5-3",
                },
            },
            {
                title: "우주의 시작",
                dom_animation: "fade_in",
                target: {
                    id: "4-5-4",
                },
            },
        ]
    },
    {
        id: "4-5-1",
        title: "신비로운 분장",
        msg: "모든 빛을 집어 삼키는 블랙홀.\n" +
            "우주의 모든 나쁜 마음이 모여\n" +
            "만들어진답니다.",
        choice_set: [
            {
                title: "무슨 말도 안 되는...",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },
    {
        id: "4-5-2",
        title: "신비로운 분장",
        msg: "별과 별이 이어져\n" +
            "만들어진 아름다운 관계를\n" +
            "우리는 별자리라고 부르죠.",
        choice_set: [
            {
                title: "낭만적이네요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },
    {
        id: "4-5-3",
        title: "신비로운 분장",
        msg: "제가 바로 외계인 입니다.",
        choice_set: [
            {
                title: "무슨 말씀이시죠?",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "4-6-0"
                }
            },
        ]
    },
    {
        id: "4-5-4",
        title: "신비로운 분장",
        msg: "음, 죄송하지만 그거 딱 하나\n" +
            "제가 모르는 분야네요.",
        choice_set: [
            {
                title: "네...",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },

    {
        id: "4-6-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "제가 외계인이라구요.\n" +
            "더 궁금한건 없어요?",
        choice_set: [
            {
                title: "텔레파시",
                dom_animation: "fade_in",
                target: {
                    id: "4-6-1",
                },
            },
            {
                title: "기술력",
                dom_animation: "fade_in",
                target: {
                    id: "4-6-2",
                },
            },
            {
                title: "의식주",
                dom_animation: "fade_in",
                target: {
                    id: "4-6-3",
                },
            },
            {
                title: "법과 제도",
                dom_animation: "fade_in",
                target: {
                    id: "4-6-4",
                },
            },
        ]
    },
    {
        id: "4-6-1",
        title: "신비로운 분장",
        msg: "혼인의 서약을 맺은\n" +
            "부부끼리는 텔레파시를 사용해요.\n" +
            "월 29,600원으로요.",
        choice_set: [
            {
                title: "네?",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },
    {
        id: "4-6-2",
        title: "신비로운 분장",
        msg: "무려, 우주정거장을 만들정도의\n" +
            "기술력을 가지고 있습니다.",
        choice_set: [
            {
                title: "그건 저희도...",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },
    {
        id: "4-6-3",
        title: "신비로운 분장",
        msg: "종종 은색 기둥이 있는 식당에서\n" +
            "상추에 삼겹살과 흰 쌀 밥.\n" +
            "거기에 쌈장과 마늘 하나.\n" +
            "싸 먹곤합니다.",
        choice_set: [
            {
                title: "네?",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },
    {
        id: "4-6-4",
        title: "신비로운 분장",
        msg: "죄 지은 자는 벌을 받고,\n" +
            "올바른 이는 대우 받는 곳!\n" +
            "....이면 좋겠네요.",
        choice_set: [
            {
                title: "음...",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "4-end"
                }
            },
        ]
    },


    {
        id: "4-10-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "아, 짓궂은 분들이군요.\n" +
            "쫗아요. 저를 놓아준다면 제가\n" +
            "아끼는 선물을 하나 드릴게요.",
        choice_set: [
            {
                title: "놓아주지 않을래요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-10-1"
                },
            },
            {
                title: "옷을 선물해주세요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-10-2"
                },
            },
            {
                title: "책을 선물해주세요..",
                dom_animation: "fade_in",
                target: {
                    id: "4-10-3"
                },
            },
            {
                title: "그냥 놓아줄게요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-10-4"
                },
            },
        ]
    },
    {
        id: "4-10-1",
        title: "신비로운 분장",
        msg: "안 놓아주셔도 소용없어요.\n" +
            "저는 사실 잡을 수 없거든요!",
        choice_set: [
            {
                title: "손을 댔으나, 그냥 통과해버렸다.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-6-0"
                }
            }
        ],
    },
    {
        id: "4-10-2",
        title: "신비로운 분장",
        msg: "좋아요.\n" +
            "멋진 옷으로 선물할게요.",
        choice_set: [
            {
                title: "고마워요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-6-0"
                }
            }
        ],
    },
    {
        id: "4-10-3",
        title: "신비로운 분장",
        msg: "좋아요.\n" +
            "우주의 신비가 담긴\n" +
            "책을 선물할게요.",
        choice_set: [
            {
                title: "고마워요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-6-0"
                }
            }
        ],
    },
    {
        id: "4-10-4",
        title: "신비로운 분장",
        msg: "역시 관대하셔라!\n" +
            "당신은 우주의 신비에\n" +
            "부합되는 사람이에요!",
        choice_set: [
            {
                title: "뭔진 모르겠지만...",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-6-0"
                }
            }
        ],
    },

    {
        id: "4-11-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "즐거움을 좇는 삶에는\n" +
            "동의해요. 하지만 저인간의\n" +
            "즐거움은 조금 역겹군요.",
        choice_set: [
            {
                title: "동의해요",
                dom_animation: "fade_in",
                target: {
                    id: "4-11-1"
                },
            },
            {
                title: "그런가요",
                dom_animation: "fade_in",
                target: {
                    id: "4-11-2"
                },
            },
            {
                title: "저는 당신의 가식이 별로에요.",
                dom_animation: "fade_in",
                target: {
                    id: "4-11-3"
                },
            },
        ]
    },
    {
        id: "4-11-1",
        title: "신비로운 분장",
        msg: "저는 당신이 아주\n" +
            "마음에 들어요!",
        choice_set: [
            {
                title: "네",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },
    {
        id: "4-11-2",
        title: "신비로운 분장",
        msg: "그렇군요. 누군가는\n" +
            "제게 동의해줄거에요...",
        choice_set: [
            {
                title: "네",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },
    {
        id: "4-11-3",
        title: "신비로운 분장",
        msg: "그렇죠!\n" +
            "똥이 무서워서 피하나요?\n" +
            "더러워서 피하지!!",
        choice_set: [
            {
                title: "맞아요",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1
                },
                target: {
                    id: "0-select",
                    next_id: "1-end"
                }
            }
        ],
    },

    {
        id: "4-12-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "와 정말 차원이 다른 연기력이네요.\n" +
            "저런 연기력을 갖기 위해서\n" +
            "가장 중요한게 뭘까요?",
        choice_set: [
            {
                title: "역할에 대한 이해",
                dom_animation: "fade_in",
                target: {
                    id: "4-12-1"
                },
            },
            {
                title: "역할에 융화",
                dom_animation: "fade_in",
                target: {
                    id: "4-12-2"
                },
            },
            {
                title: "다양한 연기경험",
                dom_animation: "fade_in",
                target: {
                    id: "4-12-3"
                },
            },
            {
                title: "적재적소의 표현력",
                dom_animation: "fade_in",
                target: {
                    id: "4-12-4"
                },
            },
        ]
    },
    {
        id: "4-12-1",
        title: "신비로운 분장",
        msg: "역할에 대한 이해가 없다면,\n" +
            "그야말로 발연기겠지요.",
        choice_set: [
            {
                title: "맞네요.",
                dom_animation: "fade_in",
                weight: {
                    forgive: 1,
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "4-12-2",
        title: "신비로운 분장",
        msg: "역할에 잘 융화된 배우는\n" +
            "실제로 배역이 존재하는 것처럼\n" +
            "느끼게 만들어요.\n" +
            "저 강아지처럼요.",
        choice_set: [
            {
                title: "맞네요.",
                dom_animation: "fade_in",
                weight: {
                    flex: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "4-12-3",
        title: "신비로운 분장",
        msg: "실전경험만큼\n" +
            "중요한게 또 있을까요?",
        choice_set: [
            {
                title: "맞네요.",
                dom_animation: "fade_in",
                weight: {
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },
    {
        id: "4-12-4",
        title: "신비로운 분장",
        msg: "적절한 순간 딱 한 번의\n" +
            "대사와 표정이 모든 것을 말하죠.",
        choice_set: [
            {
                title: "맞네요.",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1
                },
                target: {
                    id: "0-select",
                    next_id: "2-4-0"
                }
            }
        ],
    },

    {
        id: "4-13-0",
        title: "신비로운 분장",
        is_talk: true,
        dom_animation: "fade_in",
        msg: "당신은 꽤 친절해보이네요.\n" +
            "그래서 말인데,\n" +
            "제 고민 좀 들어줄래요?",
        choice_set: [
            {
                title: "건강 고민이죠?",
                dom_animation: "fade_in",
                target: {
                    id: "4-13-1"
                },
            },
            {
                title: "사회생활 고민이죠?",
                dom_animation: "fade_in",
                target: {
                    id: "4-13-2"
                },
            },
            {
                title: "돈 고민이죠?",
                dom_animation: "fade_in",
                target: {
                    id: "4-13-3"
                },
            },
            {
                title: "일 고민이죠?",
                dom_animation: "fade_in",
                target: {
                    id: "4-13-4"
                },
            },
        ]
    },
    {
        id: "4-13-1",
        title: "신비로운 분장",
        msg: "엇, 그런 건아니구요.\n" +
            "음. 역시 안되겠어요.\n" +
            "나중에 말씀드릴게요-!",
        choice_set: [
            {
                title: "(싱겁긴...)",
                dom_animation: "fade_in",
                weight: {
                    gentle: -1,
                    flex: -1,
                    forgive: -1,
                    patience: -1
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "4-13-2",
        title: "신비로운 분장",
        msg: "엇, 그런 건아니구요.\n" +
            "음. 역시 안되겠어요.\n" +
            "나중에 말씀드릴게요-!",
        choice_set: [
            {
                title: "(싱겁긴...)",
                dom_animation: "fade_in",
                weight: {
                    gentle: 2,
                    flex: 2,
                    forgive: 2,
                    patience: 2
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "4-13-3",
        title: "신비로운 분장",
        msg: "엇, 그런 건아니구요.\n" +
            "음. 역시 안되겠어요.\n" +
            "나중에 말씀드릴게요-!",
        choice_set: [
            {
                title: "(싱겁긴...)",
                dom_animation: "fade_in",
                weight: {
                    gentle: 1,
                    flex: 1,
                    forgive: 1,
                    patience: 1
                },
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },
    {
        id: "4-13-4",
        title: "신비로운 분장",
        msg: "엇, 그런 건아니구요.\n" +
            "음. 역시 안되겠어요.\n" +
            "나중에 말씀드릴게요-!",
        choice_set: [
            {
                title: "(싱겁긴...)",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                    next_id: "3-3-0"
                }
            }
        ],
    },

    // TODO
    {
        id: "4-end",
        title: "신비로운 분장",
        dom_animation: "fade_in",
        msg: "자리를 비운 것 같다.",
        choice_set: [
            {
                title: "(떠난다.)",
                dom_animation: "fade_in",
                target: {
                    id: "0-select",
                }
            },
        ]
    },
];

export const script_set = [
    intro_set,
    horror_mask_script_set,
    beast_mask_script_set,
    royal_mask_script_set,
    mystery_mask_script_set,
    ending_set
];

export const result_set = [
    {
        id: 0,
        title: "팔랑귀 코끼리 탈",
        img_url: "/story/story_2/result/00.png",
        main_img_url: "/story/story_2/result/00_main.png",
        down_img_url: "/story/story_2/download/Down-00.jpg",
        main_color: "#b294ff",
        desc_set: [
            {
                title: "팔랑귀 코끼리",
                desc: "\"그 영화 봤어? 클레멘타인! 재밌다던데?\" 팔랑귀 코끼리는 이런 유혹에 쉽게 넘어갑니다.(솔직히 이건 조금 과장이랍니다🤓 좀 심했죠?) 팔랑귀 코끼리의 이타심과 행동력이 다른 유형에 비해 높은 편이기 때문이에요. 이타심은 딱히 다른 이의 의견에 반박하지 않는 이유죠. 그리고, 유혹에 넘어가는 건 높은 행동력 때문이랍니다. 안좋아 보인다구요? 그렇지 않습니다. 반대의 경험도 많이해보셨을 거예요. 특유의 공감능력을 바탕으로 친구들이 공감할 만한 요소를 발견하고 어필하며, 주도적으로 계획을 이끌어나가는 경험을 말이에요!"
            },
            {
                title: "좋아요! 근데, 제 말도 한번 들어보세요!",
                desc: "- 상대방을 엄격하게 평가하고 비난하기보단 '왜 그랬을까?' 하고 곰곰이 생각하곤 해요.\n\n" +
                    "- 그 결과가 '완벽한 이해'에 도달하지 않는 경우엔 마음에 깊은 갈등이 생기기도 하네요.\n\n" +
                    "- 만약에 그런 갈등이 마음에 생겼다면, 억지로 이해하려고 노력하지 말고 '이해하지 않는 방법'을 선택해보세요.\n\n" +
                    "- '네가 잘 못한 게 맞어'라고 마음의 답을 내려버리면 속 시원하게 해결될 문제입니다.\n\n" +
                    "- 설득당하는 경우가 많지만, 팔랑귀 코끼리가 의도적으로 상대방을 설득하려고 하면 설득하지 못할 상대가 없어요.\n\n" +
                    "- 이타심의 양면성 때문이에요. 상대방이 원하는 바를 빠르게 이해할 수 있거든요.\n\n" +
                    "- 행동력의 특징이기도 해요. 결정한 바가 있으면 몸이 먼저 움직이거든요.\n\n" +
                    "- 몸의 행동력 만큼 마음의 행동력이 따라오면 최고로 좋을 텐데 그러지 못할 땐 멘탈이 산산조각 나기도 해요.\n\n" +
                    "- 상대방의 의견보다 앞서 스스로의 생각으로 행동하는 습관을 들이다 보면 좋아질 거예요!"
            }
        ],
        best: 6,
        worst: 9
    }, // 온온
    {
        id: 1,
        title: "독심술 승려",
        img_url: "/story/story_2/result/01.png",
        main_img_url: "/story/story_2/result/01_main.png",
        main_color: "#fec13c",
        down_img_url: "/story/story_2/download/Down-01.jpg",
        desc_set: [
            {
                title: "독심술 승려",
                desc: "말을 하지 않아도 고민을 눈치채고 먼저 위로해 주는 당신을 보면서 누군가는 \"쟤는 관심법을 쓰는 것 같아\"라고 할지도 모르겠어요. 승려 유형은 눈치도 빠르고, 오지랖도 넓은 편이거든요. 모티브가 된 승려 캐릭터와는 다르게  '누가 기침소리를 내었는가?' 같은 분위기 깨는 소리를 하며, 산통을 깨는 타입은 아니에요. 오히려 힘들어 보이는 친구의 곁에 조용하게 다가가 위로해 주는 편이죠. 말하지 않아도 \"이래저래 해서 힘들었어?\"라고 묻는 당신에게 많은 이들이 위로받고 있을 거예요."
            },
            {
                title: "네 놈 머릿속에 👿 마구니가 끼어꾸나",
                desc: "- 이야기를 잘 들어주는 소통의 달인입니다. 대화를 이어나가는 능력 또한 뛰어나지요.\n\n" +
                    "- 상대방의 고민을 들으며 같이 화내고, 공감해 줄 수 있다보니 친구들 사이에서는 상담가 포지션에 해당하겠습니다.\n\n" +
                    "- 너무 눈치가 빨라서 섬뜩한 느낌을 줄지도!? \"몰카 설치해놨어?\"\n\n" +
                    "- 높은 이해심 덕분에 친구들 사이에서는 인싸로 통하겠습니다.\n\n" +
                    "- 깊은 이해심과는 별개로 스스로의 고민을 누군가에게 이야기하는 건 잘 못하는 편입니다.\n\n" +
                    "- 마음에 갇힌 말들이 독이 되지 않도록 주의하는 것이 좋겠어요.\n\n" +
                    "- 가끔은 위로하기보다 위로받기 위한 노력을 해 보는 건 어떨까요? 위로받는 것도 큰 용기랍니다."
            },
            {title: "KEYWORDS", desc: "#관심법 #마구니 #소통 #뇌피셜 #신통방통"}
        ],
        best: 5,
        worst: 9
    }, // 온융
    {
        id: 2,
        title: "포근한 곰돌이인형",
        img_url: "/story/story_2/result/02.png",
        main_img_url: "/story/story_2/result/02_main.png",
        down_img_url: "/story/story_2/download/Down-02.jpg",
        main_color: "#8169ff",
        desc_set: [
            {
                title: "포근한 곰돌이인형",
                desc: "요즘 유행하는 말이 있죠? '사려 깊다', '선한 영향력'. 포근한 곰돌이 인형 같은 당신을 두고 하는 말입니다. 그야말로 시대가 필요로 하는 유형이네요. 사실 시대뿐만 아니라 모든 친구들이 당신 같은 사람을 주변에 두고 싶어 해요. 따뜻한 대화로 상대방을 위로해 주고, 풍요로운 마음으로 온정을 베풀 줄 알고, 어려움에 처한 친구를 가만히 두지 않는 모습을 보면서 누가 가까이 하고 싶지 않겠어요. 더군다나 생각보다 친해지기 어려운 유형이라 더더욱 친해지고 싶을 거예요. 그 이야긴 뒤에서 다시 하죠!",
            },
            {
                title: "힘들 때 제일 먼저 생각 나는 사람 🧸",
                desc: "- 곰돌이 유형은 가까운 사람을 위해 모든 것 까지는 아니더라도 많은 것을 내어줄 수 있습니다. 콩 한쪽 정도는 우습죠.\n\n" +
                    "- 하지만, 당신의 가장 큰 매력은 힘든 친구를 외면하지 못하는 데에서 옵니다. 연인과 헤어진 친구를 위해 술 한잔해줄 능력이야 누구나 있겠지만, 진심으로 공감되는 위로를 해줄 수 있는 능력은 아무나 없지요. 오로지 곰돌이 유형에게만 있습니다.\n\n" +
                    "- 비결은 무조건적 이해심입니다. 생각과 맞지 않더라도 무조건 친구의 편을 들며 친구의 입장에서 공감을 하기 위해 노력하기 때문이지요.\n\n" +
                    "- 곰돌이 유형은 사실 쉽게 마음을 열지는 않아요. 그래서 친한 친구가 많은 편은 아니죠.\n\n" +
                    "- 덕분에 여러 사람과 관계를 유지하는데 드는 에너지를 조금 절약해서 그 시간을 자기발전의 기회로 삼을 수 있답니다.\n\n" +
                    "- 왜 곰돌이 유형이 마음을 쉽게 열지 않느냐고요? 상대방을 온전히 이해하고자 하는 만큼, 스스로를 껍데기 없이 바라봐 줄 수 있는 사람을 가까이 두려고 하기 때문이래요."
            },
            {
                title: "KEYWORDS",
                desc: "#선한영향력 #라르기시모 #바다 #관계의온도 #마음기댈곳"
            },
        ],
        best: 5,
        worst: 9
    }, // 온관
    {
        id: 3,
        title: "웃음 많은 광대",
        img_url: "/story/story_2/result/03.png",
        main_img_url: "/story/story_2/result/03_main.png",
        down_img_url: "/story/story_2/download/Down-03.jpg",
        main_color: "#cbd177",
        desc_set: [
            {
                title: "웃음 많은 광대",
                desc: "당신이 찡그린 표정을 짓는 날은 해가 서쪽에서 뜨는 날입니다. 광대 유형은 누구에게나 친절합니다. 딱히 다른 사람의 의견에 반대하는 편도 아니고요. 스스로의 생각과 감정을 긍정적인 방향으로 어필하는데 집중하는 성향을 가지고 있어요. 그러다 보니 친하지 않은 사람들은 광대 유형의 겉모습만 보고 '쟤는 정말 친절하고 착하구나', '웃음이 많구나'라고 생각하기 쉽겠어요. 애초에 유한 성격일뿐더러 화가 조금 나더라도 불필요한 입씨름이나 싫은 소리가 하기 싫어 참다 보니 생긴 결과입니다.",
            },
            {
                title: "난 오늘도 니 앞에서 웃는 광대 🕺",
                desc: "- 불필요한 감정 소모를 무의식적으로 피하기 때문에 비교적 자기계발 등 다른 곳에 쓸 에너지가 많습니다.\n\n" +
                    "- 아무리 화가 나도 머릿속으로 불경을 읊듯 참아내는 인내의 아이콘입니다. 덕분에 화가 나도 잘 티가 나지 않지요.\n\n" +
                    "- 좋게좋게 넘기고 싶어서 참아내다 보니 속앓이를 하기 일쑤인데요. 아무리 성격 좋아 보이는 광대 유형이라도, 깊은 수심은 얼굴에 드러날 수밖에 없는 법입니다.\n\n" +
                    "- 이럴 때 등장하는 친구의 한마디 \"삐졌어?\"는 폭발을 일으키는 트리거입니다.\n\n" +
                    "- 참고 참아왔던 부정적인 감정을 상대방이 입 밖으로 내놓는다면 광대 유형도 더 이상 참지 않지요. 이때만큼은 무서우리만큼 화를 낼지도 모르겠어요.\n\n" +
                    "- 약점을 보이면 희생당하기 쉽던 야생과는 달리 현대 시대는 스스로에 대해 타인에게 이야기하는 것은 정말 중요한 생존 행위입니다. 스스로의 감정을 솔직하게 어필하다 보면 더욱 돈독한 관계를 만들 수 있겠습니다.\n\n" +
                    "- 진정 당신을 알아주고 이해하는 사람과는 아주 끈끈한 관계를 유지하겠습니다."
            },
            {
                title: "KEYWORDS",
                desc: "#내가웃는게아니야 #속에꽁꽁 #나무아미타불관세음보살 #삐졌어는금지어"
            }
        ],
        best: 2,
        worst: 9
    }, // 온인
    {
        id: 4,
        title: "평화를 사랑하는 예술가",
        img_url: "/story/story_2/result/04.png",
        main_img_url: "/story/story_2/result/04_main.png",
        down_img_url: "/story/story_2/download/Down-04.jpg",
        main_color: "#39ccba",
        desc_set: [
            {
                title: "평화를 사랑하는 예술가",
                desc: "사회적 현상이나, 사람들 간의 관계 속에서 새로운 현상을 관찰하고, 수용할 줄 아는 당신은 예술가 유형입니다. 이들은 스스로의 감정을 숨기지 않고, 솔직하게 표현하는 편입니다. 하지만 날이 서 있지 않고, 융통성이 높은 편이라 어지간한 말썽으로는 예술가 유형의 감정을 흔들 수 없지요. 통찰력 있는 시선으로 여러 사람의 의견을 듣고 답을 내려줄 수 있는 해결사의 역할을 주로 합니다. 주변인들의 만족도는요... 음, 100점 만점에 100점! 💯"
            },
            {
                title: "슬로우 슬로우 💃 퀵 퀵 🕺템포의 제왕",
                desc: "- 자신의 감정에 대한 표현력, 타인의 감정에 대한 수용력이 높은 편이라 주변에서 인기가 많습니다.\n\n" +
                    "- 스스로의 감정에 솔직한 편이지만, 고집을 부리지는 않아요. 대부분의 각자의 생각 나름대로 옳다고 생각하는 입장이니까요~\n\n" +
                    "- 불필요한 싸움을 싫어하는 예술가 유형은 일이 커질 것 같다 싶으면, 논쟁에서 발을 빼는 편입니다.\n\n" +
                    "- 나중에 뒤돌아서 후회하는 경우도 있는데, 어쩌겠어요 타고난 성격이 그런걸요.\n\n" +
                    "- 모두의 의견을 존중한다고 자신의 생각이 없는 건 아니죠, 예술가 유형이 중재에 타고난 재주가 있는 건 바로 이 부분입니다. 친구들의 의견을 조율하면서도 자신의 생각을 잘 이야기할 줄 알거든요.\n\n" +
                    "- 중재에 자주 나서는 탓에 입방아에 오르내리기 쉽겠습니다. 하지만, 언변 스킬을 단련하다 보면 그 입방아는 명예로운 내용들로 채워질 거예요!"
            },
            {
                title: "KEYWORDS",
                desc: "#긍정왕 #노꾸밈 #백지 #프리허그 #솔로몬"
            }
        ],
        best: 6,
        worst: 7
    }, // 융융
    {
        id: 5,
        title: "화려하게 꾸민 해골",
        img_url: "/story/story_2/result/05.png",
        main_img_url: "/story/story_2/result/05_main.png",
        down_img_url: "/story/story_2/download/Down-05.jpg",
        main_color: "#ff8a50",
        desc_set: [
            {
                title: "화려하게 꾸민 해골",
                desc: "화려하게 꾸민 해골 유형은 생각이나 감정에 대한 표현력이 아주 높습니다. 그래서 기분에 따라 아름답게 스스로를 꾸민다거나, 머릿속에 스쳐 지나간 생각을 글로 담아내는 등의 재주를 가지고 있습니다. 이들이 가진 감성은 독창적이거나 개인적인 경우가 많기 때문에 모두의 공감을 사지는 못해요. 그럼에도 불구하고 특유의 인간적인 매력 덕분에 다른 이들에게 인기가 높은 편입니다. 웬만한 유형들과도 잘 아주 어울리는 편이고요."
            },
            {
                title: "난 가끔 슬플 때 눈물을 흘린ㄷr ⭐️",
                desc: "- 감정에 솔직한 편이라, 쓴소리, 나쁜 소리 뿐만아니라 달달한 말, 칭찬도 상황에 따라 아끼지 않아요.\n\n" +
                    "- 표현력이 뛰어나기 때문에 부정적인 말은 듣기 거북하지 않게, 긍정적인 말은 더더욱 듣기 좋게 하는 재주도 가지고 있습니다.\n\n" +
                    "- 주변 사람들이 당신을 '나이스 한 사람' 이라고 생각하는 게 당연하다 보니 언제나 '나이스'하게 보이려고 하는 경향이 있어요.\n\n" +
                    "- 그러다 보니 인간관계에 지치기도 합니다. 이는 상대방에 대한 이해심이 선천적으로 조금 부족하기 때문에 이해하기 위해 진심으로 노력할 때 에너지 소모가 크기 때문이에요. (노력형 이해심)\n\n" +
                    "- 여러 사람들과의 관계에서도 멋진 모습을 유지하기 위해 애쓰다 보니 당신은 어딜 가나 인기 있습니다. 아마 지금도 안 읽은 카톡이 쌓여있겠군요.\n\n" +
                    "- 마음속 깊은 곳에서 느껴지는 공허함까지도 표현해보세요. 그럴 수 있다면 한 층 더 가벼운 마음이 될 거예요!"
            },
            {
                title: "KEYWORDS",
                desc: "#인싸 #넘치는매력 #노력파 #부재중전화수십통 #카톡개미지옥"
            }
        ],
        best: 0,
        worst: 3
    }, // 융관
    {
        id: 6,
        title: "친절한 수호자",
        img_url: "/story/story_2/result/06.png",
        main_img_url: "/story/story_2/result/06_main.png",
        down_img_url: "/story/story_2/download/Down-06.jpg",
        main_color: "#6ae5ff",
        desc_set: [
            {
                title: "친절한 수호자",
                desc: "누군가 잘못을 저지르면 어김없이 나타나 뒤에서 쳐다보고 있을 것 같은 사람이군요? 친절한 수호자들은 마음속에 불편함이 남는 것을 용납하지 않습니다. 친구들 사이에서 옳고 그름을 명확히 구분하는 탓에 자칫 불편함을 일으키는 사람으로 오해받곤 하지만, 개의치 않습니다. 수호자의 가장 큰 매력은 주변의 누군가 불의를 당할 때 빛을 발합니다. 절대 주변 사람들이 다치도록 가만히 있지 않거든요! 😡",
            },
            {
                title: "내 하트를 ❤️ 받아줘 -!",
                desc: "- 수호자는 대부분 직진 남녀 입니다. 올바른 생각이라고 스스로 확신하면 행함에 두려움이 없죠. 바로 고고입니다.\n\n" +
                    "- 자기관리에 상당히 엄격한 만큼 업무적 성과는 탁월한 편!\n\n" +
                    "- 피해를 끼치기 싫어하는 성향 덕분에 어려운 일들을 홀로 짊어지는 경향이 있습니다.\n\n" +
                    "- 이게 쌓이다 보면 큰 스트레스가 되어 수호자 유형의 몸과 마음을 상처 입게 할지도 몰라요.\n\n" +
                    "- 뜻이 잘 맞는 사람에게는 말 그대로 '친절한 수호자'입니다. 상대방을 대신해서 힘든 일, 어려운 일 모두 대신해줄 정도예요. 수호자 유형의 박애주의적 성향은 여기서도 드러납니다.\n\n" +
                    "- 반대로 뜻이 잘 맞지 않는 사람과는 친해지기가 정말 힘들어요.\n\n" +
                    "- 재미있는 점은 수호자 유형은 상대방의 생각에 그다지 신경을 쓰지 않는다는 점. 그래서 당신은 정작 아무 생각도 없는데, 상대방이 당신을 꺼려 하는 그림이 연출되곤 하죠.\n\n" +
                    "- 자신의 생각이 '옳고 그름'의 기준이라고 생각하기 때문이에요. 이게 또 잘 못하면 권위적으로 비춰질 수 있습니다."
            },
            {
                title: "KEYWORDS",
                desc: "#이타적 #박애주의 #정의 #봉사정신 #잡았다요놈"
            }
        ],
        best: 7,
        worst: 5
    }, // 융인
    {
        id: 7,
        title: "짠쿨 레인저",
        img_url: "/story/story_2/result/07.png",
        main_img_url: "/story/story_2/result/07_main.png",
        down_img_url: "/story/story_2/download/Down-07.jpg",
        main_color: "#f73f3f",
        desc_set: [
            {
                title: "짠쿨 레인저",
                desc: "세상의 모든 쿨하지 못한 것들을 지우고 나면 오로지 하나, '짠쿨레인저' 만 남습니다. 쿨하지 못하게 과거 일에 연연하고, 쿨하지 못하게 별거 아닌 걸로 싸우고... 짠쿨레인저에겐 도저히 이해 못 할 행동입니다. 물론 아무한테나 쿨한 건 아니에요. 어릴 적 만화에서 본 레인저 이름답게, 불의를 참지 못하는 짠쿨레인저는 자타공인 나쁜 놈에게는 쿨하진 않습니다. 시원하게 한바탕 후 상대방이 잘못을 인정하고 용서를 구한다면, 우리의 짠쿨레인저... 또 쿨하게 용서해 주겠지요.😎"
            },
            {
                title: "어제 우린 싸웠지만, 오늘 우린 친구야",
                desc: "- 무엇이든 용서하고 마음에 담아두는 법이 없는 짠쿨레인저는 소년만화 주인공처럼 멋있어 보입니다.\n\n" +
                    "- 짠쿨레인저의 쿨은 진짜 쿨입니다. 어디 가서 쿨한척하는 사람들이랑은 비교불가!\n\n" +
                    "- 무엇보다 큰 매력은 뒤끝이 없다는 점! 시원하게 한바탕 하고 나면 깨끗하게 잊어버리는 유형이죠.\n\n" +
                    "- 이렇게 지나간 일은 지나간 대로 흘려내는 낙천적인 성격 덕분에 부정적인 감정으로 인해 고통받거나 갈등이 생기는 경우는 정말 드물겠군요.\n\n" +
                    "- 그런데 왜 짠쿨레인저인가! 쿨하다 못해 차가운 골방에 움츠린 노총각 삼촌이 떠올라 마음이 짠해지기도 하거든요... 무슨 소리냐고요? 그건 바로... 공감 없는 쿨 때문이랍니다.\n\n" +
                    "- 당신의 마음은 용서했지만, 상대방은 용서받을 준비가 안 되어있을지도 몰라요. 화해도 관계의 개선도 혼자 하는 건 아니니까요.\n\n" +
                    "- 👏손바닥이 맞아야 소리가 난다고, 상대방의 감정과 템포를 맞추어 보세요-!"
            },
            {
                title: "KEYWORDS",
                desc: "#쿨내진동 #너의죄를사하노라 #냉골방 #정의의사도 #지나간것은지나간대로"
            }
        ],
        best: 4,
        worst: 10
    }, // 관관
    {
        id: 8,
        title: "허허실실 하회탈",
        img_url: "/story/story_2/result/08.png",
        main_img_url: "/story/story_2/result/08_main.png",
        down_img_url: "/story/story_2/download/Down-08.jpg",
        main_color: "#59d068",
        desc_set: [
            {
                title: "허허실실 하회탈",
                desc: "세상의 모든 관계가 가치 있다고 생각하지 않는 허허실실 하회탈은 가장 이성적인 유형입니다. 성격이 나빠서 그런 게 아니라 조금 계산적일 뿐이에요. 손해 보는 걸 싫어하는 사람이 어딨겠어요. 다만 하회탈 유형은 손해 보는 걸 남들 보다 좀 더 아주아주 많이 싫어할 뿐이랍니다. 허허실실 하회탈의 가장 큰 무기는 사람 좋아 보이는 너털웃음입니다. 이들의 웃음은 절대 가식이 아니에요. 관계의 중요성을 인지했을 때 나오는 찐 웃음입니다. (🧐중요)",
            },
            {
                title: "😑 실눈캐는 무서워오",
                desc: "- 하회탈 유형은 모든 것보다는 중요하게 생각하는 것에 대해 '손해 보기 싫은 마음' 이 큽니다. 돈이나 시간처럼요.\n\n" +
                    "- 누군가 손해를 끼칠 것 같다면, 당장은 출혈이 있더라도 도마뱀처럼 관계를 끊어버릴 겁니다.\n\n" +
                    "- 계산적인 속성은 사회적 생존본능에 의해 발현됩니다. 그래서 사실 관계를 깨뜨릴 만한 분노 자체를 드러내지 않는 편입니다.\n\n" +
                    "- 오히려 누구에게나 매력적으로 보이는 편입니다. 사람 좋은 웃음에 맺고 끊음 확실하고, 친절하면서도 꽤 쿨해 보이기까지 하니까요.\n\n" +
                    "- 하회탈 유형이 화가 나면, 더 이상 지금의 관계가 중요하지 않았다고 판단했을 가능성이 큽니다.\n\n" +
                    "- 그렇기 때문에 실눈 캐의 분노는 지구 멸망 수준입니다.\n\n" +
                    "- 아무리 끝내버릴 관계라고 해도, 분노의 지나친 표현은 여러 관계에 해가 됩니다. 누군가는 당신의 분노를 팝콘 튀기고 보고 있었을 수도 있거든요. 극단적인 선택보단 감정의 회색 지대를 잘 활용해보는 것도 좋겠어요!"
            },
            {
                title: "KEYWORDS",
                desc: "#실눈캐 #계산기 #이성적 #미소에속지마 #눈을뜬다면"
            }
        ],
        best: 1,
        worst: 9
    }, // 관인
    {
        id: 9,
        title: "외계에서 온 방문자",
        img_url: "/story/story_2/result/09.png",
        main_img_url: "/story/story_2/result/09_main.png",
        down_img_url: "/story/story_2/download/Down-09.jpg",
        main_color: "#b8dc2a",
        desc_set: [
            {
                title:"외계에서 온 방문자",
                desc:"주변 사람들 중 몇몇은 당신을 관측할 수 없는 신비로운 우주에서 온 방문자👽로 생각하고 있어요. 못 믿겠다고요? 가끔 \"너 AB형 아니었어?\", \"무슨 생각 해?\"같은 말을 듣곤 하잖아요? 뚱해 보이는 표정으로 남들은 잘 이해하지 못하는 말을 종종 하기 때문인데요. '무뚝뚝 + 엉뚱'이라는 키워드는 방문자 유형을 설명하는 가장 중요한 요소입니다. 사실 외계인 유형의 머릿속에는 어마무시한 공식과 생각들이 꼬리에 꼬리를 물고 있을지도 몰라요."
            },
            {
                title:"외계요? 다른 차원 아니구요?",
                desc:"- 웬만해서는 방문자 유형의 생각을 읽기는 힘들 겁니다.\n\n" +
                    "- 잘나서는 편은 아니지만, 머릿속으로 현재 상황을 여러 가지 경우의 수로 나눠 계산해보는 편이죠.\n\n" +
                    "- 그러다 보니 복잡하게 꼬인 상황이나 관계를 해결하는 묘수를 제안하기도 해서 주변을 놀래키고 하죠.\n\n" +
                    "- 감정을 솔직하게 표현하는 경우가 극히 드뭅니다. 그냥저냥 넘어가는 편이죠.\n\n" +
                    "- 내부적으로 견디는 힘도 강해서 남들 눈에는 강철 멘탈로 비춰집니다.\n\n" +
                    "- 본래 마음은 작은 결함으로도 부서질 수 있는 거대한 기계와 같습니다. 당장은 무덤덤히 넘길 수 있겠지만, 계속 쌓아두면 당연히 큰 문제를 일으킬 수 있겠죠?\n\n" +
                    "- 그러니 가끔은 본인이 겪고 있는 문제를 속 시원히 털어내고 함께 해결해보는 것도 좋아요."
            },
            {
                title:"KEYWORDS",
                desc:"#무뚝뚝 #무슨생각해 #강철멘탈 #안드로메다 #답답"
            }
        ],
        best: 8,
        worst: 0
    }, // 인인
    {
        id: 10,
        title: "분홍색 비버",
        img_url: "/story/story_2/result/10.png",
        main_img_url: "/story/story_2/result/10_main.png",
        down_img_url: "/story/story_2/download/Down-10.jpg",
        main_color: "#f179bc",
        desc_set: [
            {
                title:"분홍색 비버",
                desc:"유능하게 관계를 다룰 줄 아는 다재다능한 비버입니다. 그 형태를 정확하게 파악하기 어려울 만큼 모습이 자주 변하지만, 변한 모습 하나하나가 매력적이죠. 상황에 맞는 정확한 가면을 쓸 줄 알기 때문이에요. 적재적소에 짓는 표정과, 내뱉는 표정, 임하는 태도는 당신을 세상에서 가장 매력적인 사람으로 보이게 만들죠. 오늘도 새로운 가면을 얻기 위해 분주히 노력하는 당신의 모습을 자세히 들여다볼까요! 🦦",
            },
            {
                title:"규정할 수 없는 신비로움",
                desc:"- 처한 상황과, 주변 인물과의 관계에 따라 바꿀 수 있는 여러 개의 가면을 가지고 있습니다.\n\n" +
                    "- 타고난 센스라고 해야 할까요. 덕분에 어느 집단에 가든 기름칠을 한 것처럼 잘 어울립니다.\n\n" +
                    "- 변검이라는 가면 공연을 아시나요? 비버 유형은 같은 집단, 같은 상황이라도 타이밍에 맞게 가면을 바꿀 수 있습니다.\n\n" +
                    "- 종종 가면 속에 있는 본심이 튀어나올 때도 있는데요. 이건 좀 더 깊이 있는 상담을 해봐야 알 수 있지만 대부분 도전적인 요소를 지니고 있습니다.\n\n" +
                    "- 새로운 역할을 찾아내기 위한 도전, 집단 내에서 착용한 가면을 바꿔보기 위한 도전 등 이 이에 해당합니다.\n\n" +
                    "- 분명 언제나 완벽해 보이는 매력적인 모습을 가진 비버 유형! 하지만 눈치가 빠른 이들에게는 정체가 들통날 수 있습니다.\n\n" +
                    "- 사실 가면 바꿔쓰기는 완벽한 관계, 완벽한 역할을 위한 노력입니다.\n\n" +
                    "- 나쁜 뜻이 아니니, 누군가 이를 알아채더라도 상황은 여전히 당신의 편인 경우가 대부분일 거예요."
            },
            {
                title:"KEYWORDS",
                desc:"#문답무용 #카멜레온 #도전 #스위스아미나이프 #고집"
            }
        ],
        best: 9,
        worst: 1
    },// 무성향
];
